// This file encodes all the options and values in the solutions table

export default {
    "failures": {
        "question-2-1-1-answer-1": {
            "title": "Failure due to static overload (short term)",
            "image": "",
            "question": "",
            "id": "2.1.1.1",
            "M_row": 4,
            "M_column": -1,
            "M_parent_id": "2.1.1",
            "sub_options": []
        },
        "question-2-1-1-answer-2": {
            "title": "Failure due to dynamic loading (impact, vibration)",
            "image": "",
            "question": "",
            "id": "2.1.1.2",
            "M_row": 5,
            "M_column": -1,
            "M_parent_id": "2.1.1",
            "sub_options": []
        },
        "question-2-1-2-answer-1": {
            "title": "Failure due to repetitive loading (fatigue, mid-long term)",
            "image": "",
            "question": "",
            "id": "2.1.2.1",
            "M_row": 6,
            "M_column": -1,
            "M_parent_id": "2.1.2",
            "sub_options": []
        },
        "question-2-1-2-answer-2": {
            "title": "Failure due to static overload (creep, long term)",
            "image": "",
            "question": "",
            "id": "2.1.2.2",
            "M_row": 7,
            "M_column": -1,
            "M_parent_id": "2.1.2",
            "sub_options": []
        },
        "question-2-1-2-answer-3": {
            "title": "Failure caused by environmental effects (temperature, chemical, moisture, UV)",
            "image": "",
            "question": "",
            "id": "2.1.2.3",
            "M_row": 8,
            "M_column": -1,
            "M_parent_id": "2.1.2",
            "sub_options": []
        },
        "question-2-2-1-answer-1": {
            "title": "Excessive elastic deformation under load",
            "image": "",
            "question": "",
            "id": "2.2.1.1",
            "M_row": 10,
            "M_column": -1,
            "M_parent_id": "2.2.1",
            "sub_options": []
        },
        "question-2-2-1-answer-2": {
            "title": "Excessive environmental influence on dimensions (temperature, chemicals, moisture)",
            "image": "",
            "question": "",
            "id": "2.2.1.2",
            "M_row": 11,
            "M_column": -1,
            "M_parent_id": "2.2.1",
            "sub_options": []
        },
        "question-2-2-2-answer-1": {
            "title": "Incorrect initial part accuracy",
            "image": "",
            "question": "",
            "id": "2.2.2.1",
            "M_row": 12,
            "M_column": -1,
            "M_parent_id": "2.2.2",
            "sub_options": []
        },
        "question-2-2-2-answer-2": {
            "title": "Excessive plastic deformation under load (short term/ long term)",
            "image": "",
            "question": "",
            "id": "2.2.2.2",
            "M_row": 13,
            "M_column": -1,
            "M_parent_id": "2.2.2",
            "sub_options": []
        },
        "question-2-2-2-answer-3": {
            "title": "Excessive wear",
            "image": "",
            "question": "",
            "id": "2.2.2.3",
            "M_row": 14,
            "M_column": -1,
            "M_parent_id": "2.2.2",
            "sub_options": []
        },
        "question-2-3-1-answer-1": {
            "title": "Undesired short circuit",
            "image": "",
            "question": "",
            "id": "2.3.1.1",
            "M_row": 16,
            "M_column": -1,
            "M_parent_id": "2.3.1",
            "sub_options": []
        },
        "question-2-3-1-answer-2": {
            "title": "Electro corrosion of metallic neighbouring parts",
            "image": "",
            "question": "",
            "id": "2.3.1.2",
            "M_row": 17,
            "M_column": -1,
            "M_parent_id": "2.3.1",
            "sub_options": []
        },
        "question-2-3-2-answer-1": {
            "title": "Insufficient EMI-shielding",
            "image": "",
            "question": "",
            "id": "2.3.2.1",
            "M_row": 18,
            "M_column": -1,
            "M_parent_id": "2.3.2",
            "sub_options": []
        },
        "question-2-3-2-answer-2": {
            "title": "Undesirable blocking of signals",
            "image": "",
            "question": "",
            "id": "2.3.2.2",
            "M_row": 19,
            "M_column": -1,
            "M_parent_id": "2.3.2",
            "sub_options": []
        },
        "question-2-4-answer-1": {
            "title": "Temperature leading to failure of internals/ surroundings",
            "image": "",
            "question": "",
            "id": "2.4.1",
            "M_row": 21,
            "M_column": -1,
            "M_parent_id": "2.4",
            "sub_options": []
        },
        "question-2-4-answer-2": {
            "title": "Temperature leading to accelerated ageing of material",
            "image": "",
            "question": "",
            "id": "2.4.2",
            "M_row": 22,
            "M_column": -1,
            "M_parent_id": "2.4",
            "sub_options": []
        },
        "question-2-4-answer-3": {
            "title": "Part catches fire",
            "image": "",
            "question": "",
            "id": "2.4.3",
            "M_row": 23,
            "M_column": -1,
            "M_parent_id": "2.4",
            "sub_options": []
        },
        "question-2-5-answer-1": {
            "title": "Surface defects",
            "image": "",
            "question": "",
            "id": "2.5.1",
            "M_row": 25,
            "M_column": -1,
            "M_parent_id": "2.5",
            "sub_options": []
        },
        "question-2-5-answer-2": {
            "title": "Discoloration",
            "image": "",
            "question": "",
            "id": "2.5.2",
            "M_row": 26,
            "M_column": -1,
            "M_parent_id": "2.5",
            "sub_options": []
        },
        "question-2-5-answer-3": {
            "title": "Scratches",
            "image": "",
            "question": "",
            "id": "2.5.3",
            "M_row": 27,
            "M_column": -1,
            "M_parent_id": "2.5",
            "sub_options": []
        },
        "question-2-5-answer-4": {
            "title": "Wear marks",
            "image": "",
            "question": "",
            "id": "2.5.4",
            "M_row": 28,
            "M_column": -1,
            "M_parent_id": "2.5",
            "sub_options": []
        },
        "question-2-6-1-answer-1": {
            "title": "Incorrect power consumption",
            "image": "",
            "question": "",
            "id": "2.6.1.1",
            "M_row": 30,
            "M_column": -1,
            "M_parent_id": "2.6.1",
            "sub_options": []
        },
        "question-2-6-1-answer-2": {
            "title": "Increased thermal loading",
            "image": "",
            "question": "",
            "id": "2.6.1.2",
            "M_row": 31,
            "M_column": -1,
            "M_parent_id": "2.6.1",
            "sub_options": []
        },
        "question-2-6-1-answer-3": {
            "title": "Incorrect dynamic response (slip-stick or jamming)",
            "image": "",
            "question": "",
            "id": "2.6.1.3",
            "M_row": 32,
            "M_column": -1,
            "M_parent_id": "2.6.1",
            "sub_options": []
        },
        "question-2-6-2-answer-1": {
            "title": "Excessive wear",
            "image": "",
            "question": "",
            "id": "2.6.2.1",
            "M_row": 33,
            "M_column": -1,
            "M_parent_id": "2.6.2",
            "sub_options": []
        },
        "question-2-6-2-answer-2": {
            "title": "Formation of debris",
            "image": "",
            "question": "",
            "id": "2.6.2.2",
            "M_row": 34,
            "M_column": -1,
            "M_parent_id": "2.6.2",
            "sub_options": []
        },
        "question-2-7-answer-1": {
            "title": "Acoustic behaviour not meeting specification",
            "image": "",
            "question": "",
            "id": "2.7.1",
            "M_row": 36,
            "M_column": -1,
            "M_parent_id": "2.7",
            "sub_options": []
        },
        "question-2-7-answer-2": {
            "title": "Part resonance frequency not meeting expected level",
            "image": "",
            "question": "",
            "id": "2.7.2",
            "M_row": 37,
            "M_column": -1,
            "M_parent_id": "2.7",
            "sub_options": []
        },
        "question-2-8-answer-1": {
            "title": "Loss of sealing functionality",
            "image": "",
            "question": "",
            "id": "2.8.1",
            "M_row": 39,
            "M_column": -1,
            "M_parent_id": "2.8",
            "sub_options": []
        },
        "question-2-9-answer-1": {
            "title": "Food approval is violated",
            "image": "",
            "question": "",
            "id": "2.9.1",
            "M_row": 41,
            "M_column": -1,
            "M_parent_id": "2.9",
            "sub_options": []
        },
        "question-2-9-answer-2": {
            "title": "Chemical Compliance Regulations (such as REACH) are violated",
            "image": "",
            "question": "",
            "id": "2.9.2",
            "M_row": 42,
            "M_column": -1,
            "M_parent_id": "2.9",
            "sub_options": []
        },
        "question-2-9-answer-3": {
            "title": "Flammability requirements not met",
            "image": "",
            "question": "",
            "id": "2.9.3",
            "M_row": 43,
            "M_column": -1,
            "M_parent_id": "2.9",
            "sub_options": []
        },
        "question-2-10-answer-1": {
            "title": "Not producable with intended production process",
            "image": "",
            "question": "",
            "id": "2.10.1",
            "M_row": 45,
            "M_column": -1,
            "M_parent_id": "2.10",
            "sub_options": []
        },
        "question-2-10-answer-2": {
            "title": "Part (dis)assembly not possible with intended production process (screwing / clicking / welding / glueing / other)",
            "image": "",
            "question": "",
            "id": "2.10.2",
            "M_row": 46,
            "M_column": -1,
            "M_parent_id": "2.10",
            "sub_options": []
        }
    },
    "causes": {
        "3.1.1": {
            "title": "Not all real-use requirements are taken into account, when defining the part specifications (e.g. metal vs. plastic)",
            "image": "/assets/questions/phase-definition-specification.jpg",
            "question": "",
            "id": "3.1.1",
            "M_row": -1,
            "M_column": 5,
            "M_parent_id": "3.1",
            "sub_options": [],
            "M_parent_answer_id": "question-3-answer-1"
        },
        "3.1.2": {
            "title": "Defined part requirements are not accurately reflecting the real in-use condions",
            "image": "/assets/questions/phase-choice-material.jpg",
            "question": "",
            "id": "3.1.2",
            "M_row": -1,
            "M_column": 6,
            "M_parent_id": "3.1",
            "sub_options": [],
            "M_parent_answer_id": "question-3-answer-1"
        },
        "3.2.1": {
            "title": "Selected material does not fulfill required properties",
            "image": "/assets/questions/phase-definition-specification.jpg",
            "question": "",
            "id": "3.2.1",
            "M_row": -1,
            "M_column": 8,
            "M_parent_id": "3.2",
            "sub_options": [],
            "M_parent_answer_id": "question-3-answer-2"
        },
        "3.2.2": {
            "title": "Not all part manufacturing requirements are considered properly",
            "image": "/assets/questions/phase-choice-material.jpg",
            "question": "",
            "id": "3.2.2",
            "M_row": -1,
            "M_column": 9,
            "M_parent_id": "3.2",
            "sub_options": [],
            "M_parent_answer_id": "question-3-answer-2"
        },
        "3.3.1": {
            "title": "Design for part funtionality",
            "image": "/assets/questions/phase-definition-specification.jpg",
            "question": "",
            "id": "3.3.1",
            "M_row": -1,
            "M_column": 11,
            "M_parent_id": "3.3",
            "sub_options": [],
            "M_parent_answer_id": "question-3-answer-3"
        },
        "3.3.2": {
            "title": "Incorrectly simulated prediction of functional capability (mesh resolution, material model, fibre orientation, etc)",
            "image": "/assets/questions/phase-choice-material.jpg",
            "question": "",
            "id": "3.3.2",
            "M_row": -1,
            "M_column": 12,
            "M_parent_id": "3.3",
            "sub_options": [],
            "M_parent_answer_id": "question-3-answer-3"
        },
        "3.3.3": {
            "title": "Wrong inserts selected",
            "image": "/assets/questions/phase-design-process.jpg",
            "question": "",
            "id": "3.3.3",
            "M_row": -1,
            "M_column": 13,
            "M_parent_id": "3.3",
            "sub_options": [],
            "M_parent_answer_id": "question-3-answer-3"
        },
        "3.3.4": {
            "title": "Local orientation of fibre-reinforcement is not optimal (glassfiber, carbonfiber, etc.)",
            "image": "/assets/questions/phase-manufacturing.jpg",
            "question": "",
            "id": "3.3.4",
            "M_row": -1,
            "M_column": 14,
            "M_parent_id": "3.3",
            "sub_options": [],
            "M_parent_answer_id": "question-3-answer-3"
        },
        "3.3.5": {
            "title": "Weld line at critical location",
            "image": "/assets/questions/phase-validation.png",
            "question": "",
            "id": "3.3.5",
            "M_row": -1,
            "M_column": 15,
            "M_parent_id": "3.3",
            "sub_options": [],
            "M_parent_answer_id": "question-3-answer-3"
        },
        "3.3.6": {
            "title": "Incorrect edge radii (stress concentration)",
            "image": "/assets/questions/phase-assembly.jpg",
            "question": "",
            "id": "3.3.6",
            "M_row": -1,
            "M_column": 16,
            "M_parent_id": "3.3",
            "sub_options": [],
            "M_parent_answer_id": "question-3-answer-3"
        },
        "3.3.7": {
            "title": "Incorrect wall thickness",
            "image": "/assets/questions/phase-actual.png",
            "question": "",
            "id": "3.3.7",
            "M_row": -1,
            "M_column": 17,
            "M_parent_id": "3.3",
            "sub_options": [],
            "M_parent_answer_id": "question-3-answer-3"
        },
        "3.3.8": {
            "title": "Ineffective ribbing",
            "image": "/assets/questions/phase-definition-specification.jpg",
            "question": "",
            "id": "3.3.8",
            "M_row": -1,
            "M_column": 18,
            "M_parent_id": "3.3",
            "sub_options": [],
            "M_parent_answer_id": "question-3-answer-3"
        },
        "3.3.9": {
            "title": "Ineffective heat dissipation features (cooling ribs, contact with heatsinks)",
            "image": "/assets/questions/phase-choice-material.jpg",
            "question": "",
            "id": "3.3.9",
            "M_row": -1,
            "M_column": 19,
            "M_parent_id": "3.3",
            "sub_options": [],
            "M_parent_answer_id": "question-3-answer-3"
        },
        "3.3.10": {
            "title": "Contact pressure and/or contact speed outside of capability limits",
            "image": "/assets/questions/phase-design-process.jpg",
            "question": "",
            "id": "3.3.10",
            "M_row": -1,
            "M_column": 20,
            "M_parent_id": "3.3",
            "sub_options": [],
            "M_parent_answer_id": "question-3-answer-3"
        },
        "3.3.11": {
            "title": "Design for Manufacturing",
            "image": "/assets/questions/phase-manufacturing.jpg",
            "question": "",
            "id": "3.3.11",
            "M_row": -1,
            "M_column": 21,
            "M_parent_id": "3.3",
            "sub_options": [],
            "M_parent_answer_id": "question-3-answer-3"
        },
        "3.3.12": {
            "title": "Design not optimized for Injection Molding in combination with secondary operations",
            "image": "/assets/questions/phase-validation.png",
            "question": "",
            "id": "3.3.12",
            "M_row": -1,
            "M_column": 22,
            "M_parent_id": "3.3",
            "sub_options": [],
            "M_parent_answer_id": "question-3-answer-3"
        },
        "3.3.13": {
            "title": "Insufficient release angle",
            "image": "/assets/questions/phase-assembly.jpg",
            "question": "",
            "id": "3.3.13",
            "M_row": -1,
            "M_column": 23,
            "M_parent_id": "3.3",
            "sub_options": [],
            "M_parent_answer_id": "question-3-answer-3"
        },
        "3.3.14": {
            "title": "Mold design (for warpage, venting, Gas Counter Pressure etc.)",
            "image": "/assets/questions/phase-actual.png",
            "question": "",
            "id": "3.3.14",
            "M_row": -1,
            "M_column": 24,
            "M_parent_id": "3.3",
            "sub_options": [],
            "M_parent_answer_id": "question-3-answer-3"
        },
        "3.3.15": {
            "title": "Gate locations chosen wrongly",
            "image": "/assets/questions/phase-definition-specification.jpg",
            "question": "",
            "id": "3.3.15",
            "M_row": -1,
            "M_column": 25,
            "M_parent_id": "3.3",
            "sub_options": [],
            "M_parent_answer_id": "question-3-answer-3"
        },
        "3.3.16": {
            "title": "Gate dimensions and runner system inadequate",
            "image": "/assets/questions/phase-choice-material.jpg",
            "question": "",
            "id": "3.3.16",
            "M_row": -1,
            "M_column": 26,
            "M_parent_id": "3.3",
            "sub_options": [],
            "M_parent_answer_id": "question-3-answer-3"
        },
        "3.3.17": {
            "title": "Inadequate mold venting",
            "image": "/assets/questions/phase-design-process.jpg",
            "question": "",
            "id": "3.3.17",
            "M_row": -1,
            "M_column": 27,
            "M_parent_id": "3.3",
            "sub_options": [],
            "M_parent_answer_id": "question-3-answer-3"
        },
        "3.3.18": {
            "title": "Inadequate cooling channel placement",
            "image": "/assets/questions/phase-manufacturing.jpg",
            "question": "",
            "id": "3.3.18",
            "M_row": -1,
            "M_column": 28,
            "M_parent_id": "3.3",
            "sub_options": [],
            "M_parent_answer_id": "question-3-answer-3"
        },
        "3.3.19": {
            "title": "Insufficient coring out",
            "image": "/assets/questions/phase-validation.png",
            "question": "",
            "id": "3.3.19",
            "M_row": -1,
            "M_column": 29,
            "M_parent_id": "3.3",
            "sub_options": [],
            "M_parent_answer_id": "question-3-answer-3"
        },
        "3.3.20": {
            "title": "Design for assembly or dis-assembly",
            "image": "/assets/questions/phase-assembly.jpg",
            "question": "",
            "id": "3.3.20",
            "M_row": -1,
            "M_column": 30,
            "M_parent_id": "3.3",
            "sub_options": [],
            "M_parent_answer_id": "question-3-answer-3"
        },
        "3.3.21": {
            "title": "Thermal expansion differences between parts not sufficiently considered",
            "image": "/assets/questions/phase-actual.png",
            "question": "",
            "id": "3.3.21",
            "M_row": -1,
            "M_column": 31,
            "M_parent_id": "3.3",
            "sub_options": [],
            "M_parent_answer_id": "question-3-answer-3"
        },
        "3.3.22": {
            "title": "Assembly sequence and/or constraints not sufficiently considered",
            "image": "/assets/questions/phase-definition-specification.jpg",
            "question": "",
            "id": "3.3.22",
            "M_row": -1,
            "M_column": 32,
            "M_parent_id": "3.3",
            "sub_options": [],
            "M_parent_answer_id": "question-3-answer-3"
        },
        "3.4.1": {
            "title": "Too high amount of volatiles in the melt,  causing blistering and/or outgassing",
            "image": "/assets/questions/phase-definition-specification.jpg",
            "question": "",
            "id": "3.4.1",
            "M_row": -1,
            "M_column": 34,
            "M_parent_id": "3.4",
            "sub_options": [],
            "M_parent_answer_id": "question-3-answer-4"
        },
        "3.4.2": {
            "title": "Mismatch of Mold and Injection Molding machine dimensions",
            "image": "/assets/questions/phase-choice-material.jpg",
            "question": "",
            "id": "3.4.2",
            "M_row": -1,
            "M_column": 35,
            "M_parent_id": "3.4",
            "sub_options": [],
            "M_parent_answer_id": "question-3-answer-4"
        },
        "3.4.3": {
            "title": "Material  dried insufficiently before processing",
            "image": "/assets/questions/phase-design-process.jpg",
            "question": "",
            "id": "3.4.3",
            "M_row": -1,
            "M_column": 36,
            "M_parent_id": "3.4",
            "sub_options": [],
            "M_parent_answer_id": "question-3-answer-4"
        },
        "3.4.4": {
            "title": "Actual machine values are not corresponding with chosen settings (\"Ist\" vs.\"Soll\")",
            "image": "/assets/questions/phase-manufacturing.jpg",
            "question": "",
            "id": "3.4.4",
            "M_row": -1,
            "M_column": 37,
            "M_parent_id": "3.4",
            "sub_options": [],
            "M_parent_answer_id": "question-3-answer-4"
        },
        "3.4.5": {
            "title": "Applied Mold-release incorrect (amount, type, compatibility with secondary operations etc.)",
            "image": "/assets/questions/phase-validation.png",
            "question": "",
            "id": "3.4.5",
            "M_row": -1,
            "M_column": 38,
            "M_parent_id": "3.4",
            "sub_options": [],
            "M_parent_answer_id": "question-3-answer-4"
        },
        "3.4.6": {
            "title": "Processing settings chosen outside of material-specific Injection Molding recommendations",
            "image": "/assets/questions/phase-assembly.jpg",
            "question": "",
            "id": "3.4.6",
            "M_row": -1,
            "M_column": 39,
            "M_parent_id": "3.4",
            "sub_options": [],
            "M_parent_answer_id": "question-3-answer-4"
        },
        "3.5.1": {
            "title": "Prototype testing does not emulate critical in-use condition; conditions too harsh or too mild",
            "image": "/assets/questions/phase-definition-specification.jpg",
            "question": "",
            "id": "3.5.1",
            "M_row": -1,
            "M_column": 41,
            "M_parent_id": "3.5",
            "sub_options": [],
            "M_parent_answer_id": "question-3-answer-5"
        },
        "3.5.2": {
            "title": "Accelerated testing conditions (higher frequency, load, temperature, duration etc.) introduce failure modes not occurring in real life",
            "image": "/assets/questions/phase-choice-material.jpg",
            "question": "",
            "id": "3.5.2",
            "M_row": -1,
            "M_column": 42,
            "M_parent_id": "3.5",
            "sub_options": [],
            "M_parent_answer_id": "question-3-answer-5"
        },
        "3.5.3": {
            "title": "Incorrect execution of validation test (incorrect application of loads, environment, conditioning state, settings etc.)",
            "image": "/assets/questions/phase-design-process.jpg",
            "question": "",
            "id": "3.5.3",
            "M_row": -1,
            "M_column": 43,
            "M_parent_id": "3.5",
            "sub_options": [],
            "M_parent_answer_id": "question-3-answer-5"
        },
        "3.5.4": {
            "title": "Tested prototypes do not represent mass-production parts",
            "image": "/assets/questions/phase-manufacturing.jpg",
            "question": "",
            "id": "3.5.4",
            "M_row": -1,
            "M_column": 44,
            "M_parent_id": "3.5",
            "sub_options": [],
            "M_parent_answer_id": "question-3-answer-5"
        },
        "3.6.1": {
            "title": "Excessive stress during assembly",
            "image": "/assets/questions/phase-definition-specification.jpg",
            "question": "",
            "id": "3.6.1",
            "M_row": -1,
            "M_column": 46,
            "M_parent_id": "3.6",
            "sub_options": [],
            "M_parent_answer_id": "question-3-answer-6"
        },
        "3.6.2": {
            "title": "Dimensions outside assembly-tolerance",
            "image": "/assets/questions/phase-choice-material.jpg",
            "question": "",
            "id": "3.6.2",
            "M_row": -1,
            "M_column": 47,
            "M_parent_id": "3.6",
            "sub_options": [],
            "M_parent_answer_id": "question-3-answer-6"
        },
        "3.7.1": {
            "title": "Loads outside of specified (intended) use conditions",
            "image": "/assets/questions/phase-definition-specification.jpg",
            "question": "",
            "id": "3.7.1",
            "M_row": -1,
            "M_column": 49,
            "M_parent_id": "3.7",
            "sub_options": [],
            "M_parent_answer_id": "question-3-answer-7"
        },
        "3.7.2": {
            "title": "Environmental circumstances outside of specified (intended) use conditions",
            "image": "/assets/questions/phase-choice-material.jpg",
            "question": "",
            "id": "3.7.2",
            "M_row": -1,
            "M_column": 50,
            "M_parent_id": "3.7",
            "sub_options": [],
            "M_parent_answer_id": "question-3-answer-7"
        }
    },
    "solutions": [
        "Include the full load case and add the loadcases that are of specific relevance for plastics (creep/fatigue/chemical) into the part design and choice of relevant material properties. Choose a higher strength material. Modify design to prevent stress concentration.",
        "Choose a higher strength material. Modify design to prevent stress concentration.",
        "Upfront, make sure to consider all manufacturing relevant boundary conditions, both for the injection molding as well as secondary operation steps. Perform simulation at an early stage to cover injection molding aspects. Choose another material.",
        "Correlate simulation with actual part test-performance (boundary conditions, material card, conditioning state, loadcase, etc). Then reassess the design performance and correct material choice and design layout.",
        "Determine the required pull-out force and turn-through torque on the insert via simulation or test. Choose the right insert to fulfill this functionality.",
        "In earliest design phase make sure to consider injection point layout to optimize the balance between mechanical performance and warpage/shrinkage. Take the determined fiber orientation into account into mechanical simulations and evaluate part performance. Reinforce critical locations in the design to overcome sub-optimal local glass fiber orientations.",
        "In earliest design phase make sure to consider weld line locations and wall thickness w.r.t. needed mechanical performance. Move injection location to change weld line to non-critical location. Consider the use of flow leaders or mild hesitation. Increase wall thickness locally. Pay attention to proper venting and packing to avoid local volumetric shrinkage.",
        "Add corner radii whenever possible. Follow Envalior design guidelines (https://www.dsm.com/engineering-materials/en_US/design-guide/design-guidelines/radii-and-chamfers.html) to increase radii without negative impact to filling behaviour (volumetric shrinkage/cycle time).",
        "Increase wall thickness untill maximum possible (voids/cycle time). Utilize plastic design features (snap fits, additional ribbing, corrugations) and/or addiional fixations (snapfits/boltings/anchor). Make use of hybrid design (composite tape/metal inlay).",
        "Select material with higher thermal conductivity. Shorten the conductive pathway to the heatsink. Add additional heat dissipation features. Choose material with higher softening temperature and more stable friction vs. temperature.",
        "Check the recommended release angle for the specific material; increase if needed and possible.",
        "Select gate and runner dimensions according to process (IM) simulation to prevent material degradation and ensure proper packing. Check material viscosity as indicator for mechanical performance.",
        "Improve mold venting (limit the gap for venting to prevent flash formation). Prevent blind cores in case, lack of venting is a potential risk. Not only consider end of flow length but also venting along the flow path. In criticial cases, incorporate an overflow to prevent air entrapment in critical regions.",
        "Increase core height. Make use of active cooling of cores by using bubblers, contour cooling or high conductive core material. Apply smaller core draft angle.",
        "Create more nominal play between the components, define slot holes in the expansion direction. Optimize the gate locations in such a way that the fiber orientation facilitates minimized CLTE differences. Reconsider material pairs.",
        "Ensure proper drying in accordance with the specified injection molding recommendations. Avoid too high temperature/shear loading during processing. Improve mold venting (limit the gap for venting to prevent flash formation). Prevent blind cores in case lack of venting is a potential risk. Not only consider end of flow length but also venting along the flow path. In criticial cases, incorporate an overflow to prevent air entrapment in critical regions.",
        "Predict the window of injection molding parameters (required holding pressure, injection pressures, shot weight, cycle time, etc.). Based on this, choose appropriate machinery (barrel/nozzle-size, type of screw, clamp force).",
        "Ensure proper drying in accordance with the specified injection molding recommendations. Preferrably measure the moisture content before processing.",
        "Check key parameters of injection process manually and steer accordingly (melt temperature, shot weight, etc). In case of significant offset, recallibrate the sensors in the machine.",
        "Mold Release Angle to be adapted in the tool. If impossible/undesired to adapt, make sure that mold release agent is chosen, which is compatible with further processing steps.",
        "Download latest IMR's from Plasticsfinder.com.",
        "Redefine prototype testing in order to consider all relevant use cases.",
        "Review the applied test protocol. Compensate where necessary. Apply scaling laws when interpreting the results.",
        "Make sure to define all test conditions in an unambiguous way. Check all relevant input parameters (SOLL vs. IST). Upfront of testing, create a feeling/estimate of expected performance with \"back-of-matchbox\" calculation or simulation.",
        "Consider differences in prototype product performance vs. real production process, when evaluating mechanical outcome of tests.",
        "Make sure to use proper equipment for assembling the components (torque wrench, etc). Evaluate dimensions of injection molded components versus targeted dimensions (CAD). Check best way of tool-modification to compensate for dimensional differences.",
        "Evaluate dimensions of injection molded components versus targeted dimensions (CAD). Check best way of tool-modification to compensate for dimensional differences.",
        "Make sure to define user manual with targeted operating conditions and loadings.",
        "Improve mold venting (limit the gap for venting to prevent flash formation). Prevent blind cores in case lack of venting is a potential risk. Not only consider end of flow length but also venting along the flow path. In criticial cases, incorporate an overflow to prevent air entrapment in critical regions.",
        "Create more nominal play between the components, define slot holes in the expansion direction. Optimize the gate locations in such a way that the fiber orientation facilitates minimized CLTE differences. Reconsider material-pairs.",
        "Ensure proper drying in accordance with the specified Injection molding recommendations. Avoid too high temperature/shear loading during processing. Improve mold venting (limit the gap for venting to prevent flash formation). Prevent blind cores in case lack of venting is a potential risk. Not only consider end of flow length but also venting along the flow path. In criticial cases, incorporate an overflow to prevent air entrapment in critical regions.",
        "Ensure proper drying in accordance with the specified Injection molding recommendations. Preferrably measure the moisture content before processing.",
        "Mold Release Angle to be adapted in the tool. If impossible/undesired to adapt, make sure that mold release agent is chosen which is compatible with further processing steps.",
        "Review the applied test protocol. Compensate where necessary. Apply scaling laws when interpreting the results. Compensate for (local) viscous heating.",
        "Make sure to use proper equipment for assembling the components (torque wrench, etc). Evaluate dimensions of injection molded components versus targeted dimensions(CAD). Check best way of tool-modification to compensate for dimensional differences.",
        "Evaluate dimensions of injection molded components versus targeted dimensions(CAD). Check best way of tool-modification to compensate for dimensional differences.",
        "Increase wall thickness untill maximum possible (voids/cycle time). Utilize plastic design features (snap fits, additional ribbing, corrugations) and/or addiional fixations (snapfits/ boltings/anchor). Make use of hybrid design (composite tape/metal inlay).",
        "Create more nominal play between the components, define slot holes in the expansion direction. Optimize the gate locations in such a way that the fiber orientation facilitates minimized CLTE differences. Reconsider material-pairs",
        "Include the full load case and add the loadcases that are of specific relevance for plastics into the part design and choice of relevant material properties. Choose a higher stiffness material.",
        "Choose a higher stiffness material at the relevant temperature/environmental condition. Modify the design to increase stiffness.",
        "Take moldfilling and glassfiber orientation into account when performing a mechanical/thermal simulation. Optimize fiber orientation by changing gate locations or modifications of the shape (ribbing/thickness, etc). In case of thermoplastic composite solutions, change the orientation of the UD-Tape (or the stacking in the plybook) to match the loadpath in the part.",
        "Increase wall thickness to match the required mechanical stiffness/strength. In case the wallthickness exceeds realistic injection molding limits, geometry needs to be redesigned and/or other material needs to be considered.",
        "Add ribbing to reinforce the construction. In case (additional) ribbing is not possible due to space constraints, change material, or consider hybrid design (with metal or thermoplastic composite inlay).",
        "Consider differences in prototype product performance vs. real production process, when evaluating outcome of tests. Choose a material for prototype in accordance with real life material (e-friendly)",
        "Include the full environmental load case and add the loadcases that are of specific relevance for plastics into the part design and choice of relevant material properties.",
        "Choose a material with higher resistance against environmental conditions.",
        "Take moldfilling and glassfiber orientation into account when performing a mechanical/thermal simulation. Optimize fiber orientation by changing gate locations or modifications of the shape (ribbing/thickness, etc). In case of thermoplastic composite solutions, change the orientation of the UD-Tape (or the stacking in the plybook) to match dimensional properties in the part.",
        "Take Moldfilling and glassfiber orientation into account when performing a mechanical/thermal simulation. Optimize fiber orientation by changing gate locations or modifications of the shape (ribbing / thickness, etc). In case of thermoplastic composite solutions, change the orientation of the UD-Tape (or the stacking in the plybook) to match dimensional properties in the part.",
        "Avoid big steps in wallthickness, and make sure that thick sections in the part can still be properly packed, to avoid excessive local volumetric shrinkage. Could be assessed via mold-filling simulations.",
        "Add ribbing to stabilize the construction. In case (additional) ribbing is not possible due to space constraints, change material, or consider hybrid design (with meta  or thermoplastic composite inlay).",
        "Choose sufficient release angle and ejector pin locations to avoid plastic deformation during ejection of the part.",
        "Choose gates positions such that thick sections in the part can still be properly packed, to avoid excessive local volumetric shrinkage. Could be assessed via mold-filling simulations.",
        "Choose gate and runner dimensions such that thick sections in the part can still be properly packed, to avoid excessive local volumetric shrinkage. Could be assessed via mold-filling simulations.",
        "Choose position and thickness of cooling channels, and coolant flow in such a way that thick sections in the part can still be properly cooled and a homogeneous temperature distribution can be expected. Could be assessed via mold-filling simulations including cooling system.",
        "Try to reduce local excessive wallthickness. If not possible, work with sliders. Choose position and thickness of cooling channels, and coolant flow in such a way that thick sections in the part can still be properly cooled and a homogeneous temperature distribution can be expected. Could be assessed via mold-filling simulations including cooling system.",
        "Predict the window of injection molding parameters (required holding pressure, injection pressures, shot weight, cycle time, etc.). Based on this, choose appropriate machinery (barrel / nozzle-size, type of screw, clamp force).",
        "Choose a higher stiffness material at the relevant temperature / environmental condition. Modify the design to increase stiffness.",
        "Take Moldfilling and glassfiber orientation into account when performing a mechanical/thermal simulation. Optimize fiber orientation by changing gate locations or modifications of the shape (ribbing/thickness, etc). In case of thermoplastic composite solutions, change the orientation of the UD-Tape (or the stacking in the plybook) to match the loadpath in the part.",
        "Add ribbing to reinforce the construction. In case (additional) ribbing is not possible due to space constraints, change material, or consider hybrid design (with metal  or thermoplastic composite inlay)",
        "Consider differences in prototype product performance vs. real production process, when evaluating outcome of tests",
        "Include the full load case and add the loadcases that are of specific relevance for plastics into the part design and choice of relevant material properties. Choose a higher abrasion resistant material",
        "Include the full load case and add the loadcases that are of specific relevance for plastics into the part design and choice of relevant material properties. Choose a higher abrasion resistant material.",
        "Choose a higher abrasion resistant material.",
        "Correlate wear and friction predictions with actual part test-performance (boundary conditions, material card, conditioning state, PV-loadcase, etc). Then reassess the design performance and correct material choice and design layout.",
        "Increase contact area to avoid high peak load, reduce the relative speed, add lubrication, change material choice/reconsider material pairing. Change design to allow for excessive wear.",
        "Make sure to define all test conditions in an unambiguous way. Check all relevant input parameters (SOLL vs. IST). Upfront of testing, create a feeling / estimate of expected performance with \"back-of-matchbox\" calculation or simulation.",
        "Include the full load case and add the loadcases that are of specific relevance for plastics into the part design and choice of relevant material properties. Choose a material with higher electric-resistivity properties.",
        "Choose a material with higher electric-resistivity properties at the targeted temperature/environmental condition. Modify the design to increase distance between the poles.",
        "Choose a material with higher electric-resistivity properties at the targeted temperature/environmental condition. Modify the design to increase distance between the poles, or increase wallthickness.",
        "Choose a mold release agent which doesn't influence surface conductivity of the plastic.",
        "Consider differences in prototype product performance vs. real production process, when evaluating outcome of tests. Choose a material for prototype in accordance with real-life material (e-friendly).",
        "Include the full load case and add the loadcases that are of specific relevance for plastics into the part design and choice of relevant material properties. Choose an E-Friendly material.",
        "Make sure to choose an E-Friendly material.",
        "Choose metal for inserts which is compatible with surrounding metal parts.",
        "Include the full load case and add the loadcases that are of specific relevance for plastics into the part design and choice of relevant material properties. Choose a higher conductive material and make sure that it's grounded properly.",
        "Choose a higher conductive material. Modify the design to avoid gaps, and antenna effects. Perform simulation to quantify the performance.",
        "In case of thermoplastic composite solutions, change the orientation of the UD-Tape (or the stacking in the plybook) by optimizing it versus the polarisation direction of the source.",
        "Choose a material with higher shielding capabilities for the desired frequency range. Increase wallthickness. Choose other shielding solution, which is not relying on the wallthickness of the plastic material.",
        "Take differences in (anisotropic) CLTE into account, to avoid gaps from occurring.",
        "Consider differences in prototype product performance vs. real production process, when evaluating outcome of tests.",
        "Make sure that there are no unintended gaps after assembly that can influence the EMI performance.",
        "Include the full load case and add the loadcases that are of specific relevance for plastics into the part design and choice of relevant material properties. Choose a material that's transparent for the targeted signals.",
        "Choose a more transparent material for the targeted signal range. Perform simulation to quantify the performance",
        "If it's not possible to move the inserts out of the signal beam, choose inserts that are not blocking the targeted signal. E.g. use plastic or composite inserts.",
        "Include the full load case and add the loadcases that are of specific relevance for plastics into the part design and choice of relevant material properties.",
        "Choose a material with higher thermal conductivity, or modify the design to improve thermal household.",
        "Correlate simulation with actual part test-performance (boundary conditions, material card, thermal loadcase, etc). Then reassess the design performance and correct material choice and design layout.",
        "Choose a material with tuned thermal conductivity, or modify the wall thickness to improve thermal household.",
        "Choose a material with tuned thermal conductivity, or modify the rib pattern to improve thermal convection. Shorten the path to the heat sink.",
        "Take differences in (anisotropic) CLTE into account, to avoid interruptions of thermal conductive paths and local overheating.",
        "avoid interruptions of thermal conductive paths and local overheating",
        "Include the full load case and add the loadcases that are of specific relevance for plastics into the part design and choice of relevant material properties. Choose a material with higher thermal resistance.",
        "Choose a material with higher thermal conductivity, or modify the design to improve thermal household. Choose a material with higher thermal ageing resistance.",
        "Choose a material with higher thermal conductivity, or modify the wall thickness to improve thermal household. Choose a material with higher thermal ageing resistance.",
        "Choose a material with higher thermal conductivity, or modify the rib pattern to improve thermal convection. Shorten the path to the heatsink.",
        "Include the full load case and add the loadcases that are of specific relevance for plastics into the part design and choice of relevant material properties. Choose a material with better flame retardance or better thermal conductivity.",
        "Choose a material with higher thermal conductivity, or modify the design to improve thermal household. Choose a material with higher flame retardance rating.",
        "avoid interruptions of thermal conductive paths and local overheating. Make sure the clearance between the part and its heat-radiating surroundings is sufficient",
        "Take into account any possible use and environmental conditions that may influence part surface quality.",
        "When choosing a material, consider all material properties, also those that could affect surface appearance.",
        "Optimize part design to include requirements regarding IM (e.g. too thick wall thickness leads to sink marks).",
        "Reconsider tool gate location to reduce glass fiber read-out.",
        "Fine-tune part design and/or tool gate location to optimize location of weldline.",
        "Core out thick areas or optimize wall thickness to prevent sink marks.",
        "Optimize design, increase part surface area to get rid of excessive heat. Shorten the conductive pathway to the heatsink.",
        "Optimize design (e.g. increase contact surface area) to reduce contact pressure and/or speed.",
        "Follow design guidelines for specific secondary operations (e.g. welding, glueing etc.).",
        "Make conscious decision about gate location to hide potential surface defects at gate location.",
        "Optimize gate and runner dimensions/layout for specific tool design and material of choice.",
        "Optimize mold venting for specific tool design and material of choice.",
        "Optimize cooling system layout for specific tool design and material of choice.",
        "Follow injection molding recommendations for specific material.",
        "Choose mold/machine-combination based on tool size, shot volume, material of choice, tool clamping force.",
        "Follow injection molding recommendation for specific material.",
        "Make sure that test is representative for actual use conditions.",
        "Make sure that test is executed accurately and according to specified test conditions.",
        "Only interpret test results if you're certain that prototypes are representative of commercial production parts.",
        "Optimize design to keep part deformation within elastic range during assembly.",
        "In part design, consider applying clearance between parts to compensate for dimensional variation.",
        "In part design, take into account potential misuse (e.g. excessive loading).",
        "In part design, take into account potential misuse.",
        "Optimize design, increase part surface area to get rid of excessive heat. Shorten thermal pathway to the heatsink.",
        "Only interpret test results if you're certain that prototypes are representative of commercial production parts",
        "Optimize design to keep part deformation within elastic range during assembly",
        "Consider the effects of combined loadcases that are of specific relevance for plastics. Friction interface may heat up, wear down, change roughness etc. Review how friction coefficient depends on temperature.",
        "Consider actual in-use interface conditions due to wear and friction heating etc. Review the plastic/counter surface combination regarding Coefficient of Friction at the in-use temperature, roughness, speed and pressure.",
        "Consider actual in-use interface conditions due to wear and friction heating etc. Review the choice of plastic/counter surface combination regarding Coefficient of Friction at the in-use temperature, roughness, speed and pressure.",
        "Anticipate on run-in effects as friction may change during initial use. Lubricate for proper run-in during assembly.",
        "Include change in local load case and material properties due to ongoing wear, heating, wear debis etc.",
        "Avoid abrasive reinforcement fibre to wear down counter surface.",
        "Correct radii to create a more uniform surface normal stress.",
        "Increase friction interface surface area. Choose material with higher softening temperature and more stable friction vs. temperature.",
        "Anticipate on run-in effects. Consider lubrication. Avoid excessive mold release. Check mold cleaning interval.",
        "Perform a thermal simulation to assess transient and equilibrium temperature profile between all potential heat sources and heat sinks. Check tolerance stack for sufficient free play at high temperature conditions. Design for Thermal expansion.",
        "Review release angle. Reduce application of release agent.",
        "Increase tool temperature to increase crystallinity at the surface skin layer. Follow injection molding recommendations for specific material.",
        "Check the heat sink conditions of prototype mounting and ambient (air flow speed, temperature, radiation etc.). Accelerated testing conditions probe unrealistic failure modes. Define all test conditions in an unambiguous way.",
        "Review the applied test protocol for excessive friction heating. Compensate (e.g. heat sink capacity) where necessary.",
        "Check all relevant input parameters (SOLL vs. IST). Upfront of testing, create a feeling/estimate of expected performance with \"back-of-envelope\" calculation or simulation.",
        "Check clearance at friction interface.",
        "Check for dirt contamination at friction interface.",
        "Consider the effects of combined loadcases that are of specific relevance for plastics. Friction interface may heat up, wear down, change roughness etc. Review heat sinking and thermal conductive pathways.",
        "Review material choice for thermal conductivity, heat stability and coefficient of friction. Review design (cross section and length) for the complete thermal conductive pathway between heat source and heat sink. Choose material with higher softening point.",
        "Perform a thermal simulation to assess transient and equilibrium temperature profile between all potential heat sources and heat sinks.",
        "Reconsider dynamic behavior due to static vs. dynamic friction, system's elastic deformation, inertia and damping. Friction interface may heat up, wear down, change roughness etc. Review clearance due to thermal expansion differences.",
        "Review material properties like static vs. dynamic friction, stiffness and damping. Optimize material choice.",
        "Check tolerance stack foro freeplay. Perform run-in procedure during assembly.",
        "Consider Multi-Body-Dynamics simulation on the system  or sub-assembly.",
        "Check tolerance stack for clearance at weld line.",
        "imporve shear stiffness of the friction interface.",
        "Consider the effects of combined loadcases that are of specific relevance for plastics. Friction interface may heat up, wear down, change roughness etc. Reveiw it's effect on wear rate.",
        "Review the plastic/counter surface combination regarding wear resistance and design at the in-use temperature, roughness, speed and pressure.",
        "Choose a higher abrasion resistant material  at the in-use temperature, roughness, speed and pressure.",
        "Upfront, make sure to consider all manufacturing relevant boundary conditions, including injection molding and secondary operations. Perform simulation at an early stage to cover injection molding aspects. Optimize material choice.",
        "Increase contact area to avoid high peak load, reduce the relative speed, add lubrication, change materialchoice / reconsider material pairing. Change design to allow for high wear.",
        "Check for part porostiy due to premature gate freeze off. Increase gate dimensions, runner temperature settings.",
        "Prevent excessive degradation during processing which degrades the wear resistance. Follow injection molding recommendations for specific material. Measure solution viscosity on molded part.",
        "Ensure proper drying in accordance with the specified Injection molding recommendations. Measure the moisture content before processing. Follow injection molding recommendations for specific material. Measure solution viscosity on molded part.",
        "Ensure proper drying in accordance with the specified Injection molding recommendations. Measure the actual moisture content before processing. Measure solution viscosity on molded part.",
        "Prevent excessive degradation during processing which degrades the wear resistance. Measure the part solution viscosity. Follow injection molding recommendations for specific material.",
        "Prevent excessive degradation during prototype vs. commercial part production which degrades the wear resistance when evaluating mechanical outcome of tests",
        "Friction interface may heat up, wear down, change roughness etc. Accumulate wear debris at a location where it does not affect lubrication and/or clearance.",
        "Review the plastic/counter surface combination regarding wear resistance and design at the in-use temperature, roughness, speed, pressure and end-of-life acceptable wear.",
        "Include end-of-life wear condition into simulation.",
        "Include accelerated wear at high contact pressure conditions in the design evaluation.",
        "Prevent excessive degradation during processing which degrades the wear resistance. Follow injection molding recommendations for specific material.  Measure solution viscosity on molded part.",
        "Prevent excessive degradation during processing which degrades the wear resistance. Measure solution viscosity on molded part.",
        "Take into account any possible use and environmental conditions that may influence part NVH performance. Review Structure borne and Air borne noise pathways.",
        "When choosing a material, consider all material properties, also those that could affect NVH performance. Review Structure borne and Air borne noise pathways. Check Eigenfrequencies.",
        "Make sure that simulation makes use of correct material data and boundary and loading conditions. Review Structure borne and Air borne noise pathways.",
        "Material of inserts can influence NVH performance. Review structure borne and air born noise pathways. Check Eigenfrequencies.",
        "Reconsider tool gate location to influence glass fiber orientation (which, in turn, influences NVH performance). Check Eigenfrequencies.",
        "Modify wall thickness or add stiffening features to optimize NVH performance. Check Eigenfrequencies. Review Structure borne and Air borne noise pathways.",
        "Review structure born and air born noise pathways.",
        "Review design for structure born and air born noise pathways.",
        "Take into account any possible use and environmental conditions that may influence part NVH performance. Check Eigenfrequencies.",
        "When choosing a material, consider all material properties, also those that could affect NVH performance. Check Eigenfrequencies.",
        "Make sure that simulation makes use of correct material data and boundary and loading conditions.  Check Eigenfrequencies. Perform multi-body simulations.",
        "Material of inserts can influence NVH performance. Check Eigenfrequencies.",
        "modify wall thickness or add stiffening features to optimize NVH performance. Check Eigenfrequencies.",
        "Take into account any possible use and environmental conditions that may influence part sealing behavior.",
        "Take into account any possible use and environmental conditions that may influence part sealing behaviour",
        "When choosing a material, consider all material properties, also those that could affect sealing behaviour.",
        "Optimize part design to include requirements regarding IM (make sure that part deformation is within tolerances to ensure proper sealing performance).",
        "Choose inserts that can transfer (and hold over time) the required tension force in the bolts to ensure sealing performance.",
        "Reconsider tool gate location to optimize part stiffness and prevent part deformation.",
        "Core out thick areas or optimize wall thickness to prevent deformation leading to loss of sealing performance.",
        "Optimize design, increase part surface area to get rid of excessive heat. Shorten the conductive pathway to the heatsink to prevent excessive thermal expansion.",
        "Make conscious decision about gate location to prevent part deformation/warpage.",
        "If sealing relies on fit between parts, take differences in (anisotropic) CLTE into account. Alternatively, consider other ways of sealing (e.g. add separate seal part).",
        "Mold release angle to be adapted in the tool. If impossible/undesired to adapt, make sure that mold release agent is chosen which is compatible with further processing steps.",
        "Choose sealing method wisely. Consider using a dedicated sealing part in case it's difficult to keep dimensions within tolerance.",
        "Include the requirements that are of specific relevance for plastics during choice of relevant material grade.",
        "Include the requirements that are of specific relevance for plastics during choice of relevant material grade",
        "Choose a material that fits the legal requirements for the application.",
        "Make sure that the part is produced according Good Manufacturing Practice requirements, and in correspondence with FDA standards.",
        "Make sure that the inserts meet the regulation requirements.",
        "Make sure that used mold release agent is not in conflict with Food approval requirements and REACH.",
        "Include the compliancy requirements that are of specific relevance for plastics during choice of relevant material grade.",
        "Include the compliancy requirements that are of specific relevance for plastics during choice of relevant material grade",
        "Choose a material that fits the legal requirements for the application",
        "Minimum wallthickness in combination with chosen material should meet the required flammability requirements.",
        "Follow recommendations regarding steel/hotrunner material choices, in order to be compatible with FR additives.",
        "Follow design guidelines for specific manufacturing method (e.g. injection molding, blowmolding etc.) and secondary operations (e.g. welding, glueing etc.).",
        "Make conscious decision about gate location to ensure proper material flow and filling of cavity.",
        "Core out thick areas or optimize wall thickness to prevent production issues.",
        "When defining specifications, also consider (dis)assembly of the part during its lifetime.",
        "When defining specifications, also consider (dis)assembly of the part during its lifetime",
        "When choosing a material, consider all material properties, also those that could affect the (dis)assembly of the part.",
        "Make sure that inserts are suitable for specific (dis)assembly conditions.",
        "Reconsider tool gate location to influence glass fiber orientation in order to fulfill the specific (dis)assembly conditions (part stiffness/strength/prevent excessive warpage).",
        "Add corner radii to prevent excessive stress concentration during (dis)assembly.",
        "Modify wall thickness or add stiffening features to optimize part strength and stiffness for (dis)assembly.",
        "Add stiffening features to optimize part strength and stiffness for (dis)assembly.",
        "Core out thick areas or optimize wall thickness to prevent assembly issues.",
        "(Dis)assembly order and requirements should be taken into account in the part design process.",
        "Redefine prototype testing in order to consider all relevant use cases and environmental conditions.",
        "Be aware that accelerated tests can cause unwanted side effects (e.g. heat) that may lead to unrealistic failure modes."
    ],
    "solution_table": {
        "question-2-1-1-answer-1": {
            "question-3-answer-1": {
                "question-3-1-answer-1": 0,
                "question-3-1-answer-2": 0
            },
            "question-3-answer-2": {
                "question-3-2-answer-1": 1,
                "question-3-2-answer-2": 2
            },
            "question-3-answer-3": {
                "question-3-3-answer-2": 3,
                "question-3-3-answer-3": 4,
                "question-3-3-answer-4": 5,
                "question-3-3-answer-5": 6,
                "question-3-3-answer-6": 7,
                "question-3-3-answer-7": 8,
                "question-3-3-answer-9": 9,
                "question-3-3-answer-13": 10,
                "question-3-3-answer-16": 11,
                "question-3-3-answer-17": 12,
                "question-3-3-answer-19": 13,
                "question-3-3-answer-21": 14
            },
            "question-3-answer-4": {
                "question-3-4-answer-1": 15,
                "question-3-4-answer-2": 16,
                "question-3-4-answer-3": 17,
                "question-3-4-answer-4": 18,
                "question-3-4-answer-5": 19,
                "question-3-4-answer-6": 20
            },
            "question-3-answer-5": {
                "question-3-5-answer-1": 21,
                "question-3-5-answer-2": 22,
                "question-3-5-answer-3": 23,
                "question-3-5-answer-4": 24
            },
            "question-3-answer-6": {
                "question-3-6-answer-1": 25,
                "question-3-6-answer-2": 26
            },
            "question-3-answer-7": {
                "question-3-7-answer-1": 27
            }
        },
        "question-2-1-1-answer-2": {
            "question-3-answer-1": {
                "question-3-1-answer-1": 0,
                "question-3-1-answer-2": 0
            },
            "question-3-answer-2": {
                "question-3-2-answer-1": 1,
                "question-3-2-answer-2": 2
            },
            "question-3-answer-3": {
                "question-3-3-answer-2": 3,
                "question-3-3-answer-3": 4,
                "question-3-3-answer-4": 5,
                "question-3-3-answer-5": 6,
                "question-3-3-answer-6": 7,
                "question-3-3-answer-7": 8,
                "question-3-3-answer-9": 9,
                "question-3-3-answer-13": 10,
                "question-3-3-answer-16": 11,
                "question-3-3-answer-17": 28,
                "question-3-3-answer-19": 13,
                "question-3-3-answer-21": 29
            },
            "question-3-answer-4": {
                "question-3-4-answer-1": 30,
                "question-3-4-answer-2": 16,
                "question-3-4-answer-3": 31,
                "question-3-4-answer-4": 18,
                "question-3-4-answer-5": 32,
                "question-3-4-answer-6": 20
            },
            "question-3-answer-5": {
                "question-3-5-answer-1": 21,
                "question-3-5-answer-2": 33,
                "question-3-5-answer-3": 23,
                "question-3-5-answer-4": 24
            },
            "question-3-answer-6": {
                "question-3-6-answer-1": 34,
                "question-3-6-answer-2": 35
            },
            "question-3-answer-7": {
                "question-3-7-answer-1": 27
            }
        },
        "question-2-1-2-answer-1": {
            "question-3-answer-1": {
                "question-3-1-answer-1": 0,
                "question-3-1-answer-2": 0
            },
            "question-3-answer-2": {
                "question-3-2-answer-1": 1,
                "question-3-2-answer-2": 2
            },
            "question-3-answer-3": {
                "question-3-3-answer-2": 3,
                "question-3-3-answer-3": 4,
                "question-3-3-answer-4": 5,
                "question-3-3-answer-5": 6,
                "question-3-3-answer-6": 7,
                "question-3-3-answer-7": 8,
                "question-3-3-answer-9": 9,
                "question-3-3-answer-13": 10,
                "question-3-3-answer-16": 11,
                "question-3-3-answer-17": 28,
                "question-3-3-answer-19": 13,
                "question-3-3-answer-21": 29
            },
            "question-3-answer-4": {
                "question-3-4-answer-1": 30,
                "question-3-4-answer-2": 16,
                "question-3-4-answer-3": 31,
                "question-3-4-answer-4": 18,
                "question-3-4-answer-5": 32,
                "question-3-4-answer-6": 20
            },
            "question-3-answer-5": {
                "question-3-5-answer-1": 21,
                "question-3-5-answer-2": 33,
                "question-3-5-answer-3": 23,
                "question-3-5-answer-4": 24
            },
            "question-3-answer-6": {
                "question-3-6-answer-1": 34,
                "question-3-6-answer-2": 35
            },
            "question-3-answer-7": {
                "question-3-7-answer-1": 27
            }
        },
        "question-2-1-2-answer-2": {
            "question-3-answer-1": {
                "question-3-1-answer-1": 0,
                "question-3-1-answer-2": 0
            },
            "question-3-answer-2": {
                "question-3-2-answer-1": 1,
                "question-3-2-answer-2": 2
            },
            "question-3-answer-3": {
                "question-3-3-answer-2": 3,
                "question-3-3-answer-3": 4,
                "question-3-3-answer-4": 5,
                "question-3-3-answer-5": 6,
                "question-3-3-answer-6": 7,
                "question-3-3-answer-7": 36,
                "question-3-3-answer-9": 9,
                "question-3-3-answer-13": 10,
                "question-3-3-answer-16": 11,
                "question-3-3-answer-17": 28,
                "question-3-3-answer-19": 13,
                "question-3-3-answer-21": 37
            },
            "question-3-answer-4": {
                "question-3-4-answer-1": 30,
                "question-3-4-answer-2": 16,
                "question-3-4-answer-3": 31,
                "question-3-4-answer-4": 18,
                "question-3-4-answer-5": 32,
                "question-3-4-answer-6": 20
            },
            "question-3-answer-5": {
                "question-3-5-answer-1": 21,
                "question-3-5-answer-2": 22,
                "question-3-5-answer-3": 23,
                "question-3-5-answer-4": 24
            },
            "question-3-answer-6": {
                "question-3-6-answer-1": 34,
                "question-3-6-answer-2": 35
            },
            "question-3-answer-7": {
                "question-3-7-answer-1": 27
            }
        },
        "question-2-1-2-answer-3": {
            "question-3-answer-1": {
                "question-3-1-answer-1": 0,
                "question-3-1-answer-2": 0
            },
            "question-3-answer-2": {
                "question-3-2-answer-1": 1
            },
            "question-3-answer-5": {
                "question-3-5-answer-1": 21,
                "question-3-5-answer-2": 22,
                "question-3-5-answer-3": 23,
                "question-3-5-answer-4": 24
            },
            "question-3-answer-7": {
                "question-3-7-answer-2": 27
            }
        },
        "question-2-2-1-answer-1": {
            "question-3-answer-1": {
                "question-3-1-answer-1": 38,
                "question-3-1-answer-2": 38
            },
            "question-3-answer-2": {
                "question-3-2-answer-1": 39
            },
            "question-3-answer-3": {
                "question-3-3-answer-2": 3,
                "question-3-3-answer-4": 40,
                "question-3-3-answer-7": 41,
                "question-3-3-answer-8": 42,
                "question-3-3-answer-21": 29
            },
            "question-3-answer-5": {
                "question-3-5-answer-1": 21,
                "question-3-5-answer-2": 22,
                "question-3-5-answer-3": 23,
                "question-3-5-answer-4": 43
            },
            "question-3-answer-7": {
                "question-3-7-answer-1": 27
            }
        },
        "question-2-2-1-answer-2": {
            "question-3-answer-1": {
                "question-3-1-answer-1": 44,
                "question-3-1-answer-2": 44
            },
            "question-3-answer-2": {
                "question-3-2-answer-1": 45
            },
            "question-3-answer-3": {
                "question-3-3-answer-4": 46
            },
            "question-3-answer-5": {
                "question-3-5-answer-1": 21,
                "question-3-5-answer-2": 22,
                "question-3-5-answer-3": 23,
                "question-3-5-answer-4": 43
            },
            "question-3-answer-7": {
                "question-3-7-answer-2": 27
            }
        },
        "question-2-2-2-answer-1": {
            "question-3-answer-2": {
                "question-3-2-answer-2": 2
            },
            "question-3-answer-3": {
                "question-3-3-answer-2": 3,
                "question-3-3-answer-4": 47,
                "question-3-3-answer-7": 48,
                "question-3-3-answer-8": 49,
                "question-3-3-answer-13": 50,
                "question-3-3-answer-15": 51,
                "question-3-3-answer-16": 52,
                "question-3-3-answer-18": 53,
                "question-3-3-answer-19": 54
            },
            "question-3-answer-4": {
                "question-3-4-answer-2": 55,
                "question-3-4-answer-4": 31,
                "question-3-4-answer-5": 32,
                "question-3-4-answer-6": 20
            },
            "question-3-answer-5": {
                "question-3-5-answer-1": 21,
                "question-3-5-answer-3": 23,
                "question-3-5-answer-4": 43
            },
            "question-3-answer-6": {
                "question-3-6-answer-1": 34,
                "question-3-6-answer-2": 35
            }
        },
        "question-2-2-2-answer-2": {
            "question-3-answer-1": {
                "question-3-1-answer-1": 38,
                "question-3-1-answer-2": 38
            },
            "question-3-answer-2": {
                "question-3-2-answer-1": 56
            },
            "question-3-answer-3": {
                "question-3-3-answer-2": 3,
                "question-3-3-answer-4": 57,
                "question-3-3-answer-7": 41,
                "question-3-3-answer-8": 58,
                "question-3-3-answer-21": 29
            },
            "question-3-answer-4": {
                "question-3-4-answer-2": 16,
                "question-3-4-answer-3": 17,
                "question-3-4-answer-4": 31,
                "question-3-4-answer-6": 20
            },
            "question-3-answer-5": {
                "question-3-5-answer-1": 21,
                "question-3-5-answer-3": 23,
                "question-3-5-answer-4": 59
            },
            "question-3-answer-6": {
                "question-3-6-answer-1": 34,
                "question-3-6-answer-2": 35
            },
            "question-3-answer-7": {
                "question-3-7-answer-1": 27
            }
        },
        "question-2-2-2-answer-3": {
            "question-3-answer-1": {
                "question-3-1-answer-1": 60,
                "question-3-1-answer-2": 61
            },
            "question-3-answer-2": {
                "question-3-2-answer-1": 62,
                "question-3-2-answer-2": 2
            },
            "question-3-answer-3": {
                "question-3-3-answer-2": 63,
                "question-3-3-answer-10": 64
            },
            "question-3-answer-4": {
                "question-3-4-answer-3": 17,
                "question-3-4-answer-4": 31
            },
            "question-3-answer-5": {
                "question-3-5-answer-1": 21,
                "question-3-5-answer-2": 22,
                "question-3-5-answer-3": 65,
                "question-3-5-answer-4": 43
            },
            "question-3-answer-7": {
                "question-3-7-answer-1": 27
            }
        },
        "question-2-3-1-answer-1": {
            "question-3-answer-1": {
                "question-3-1-answer-1": 66,
                "question-3-1-answer-2": 66
            },
            "question-3-answer-2": {
                "question-3-2-answer-1": 67
            },
            "question-3-answer-3": {
                "question-3-3-answer-7": 68
            },
            "question-3-answer-4": {
                "question-3-4-answer-5": 69
            },
            "question-3-answer-5": {
                "question-3-5-answer-1": 21,
                "question-3-5-answer-3": 23,
                "question-3-5-answer-4": 70
            }
        },
        "question-2-3-1-answer-2": {
            "question-3-answer-1": {
                "question-3-1-answer-1": 71,
                "question-3-1-answer-2": 71
            },
            "question-3-answer-2": {
                "question-3-2-answer-1": 72
            },
            "question-3-answer-3": {
                "question-3-3-answer-3": 73
            },
            "question-3-answer-5": {
                "question-3-5-answer-1": 21,
                "question-3-5-answer-3": 23,
                "question-3-5-answer-4": 70
            },
            "question-3-answer-7": {
                "question-3-7-answer-2": 27
            }
        },
        "question-2-3-2-answer-1": {
            "question-3-answer-1": {
                "question-3-1-answer-1": 74,
                "question-3-1-answer-2": 74
            },
            "question-3-answer-2": {
                "question-3-2-answer-1": 75
            },
            "question-3-answer-3": {
                "question-3-3-answer-2": 3,
                "question-3-3-answer-4": 76,
                "question-3-3-answer-7": 77,
                "question-3-3-answer-21": 78
            },
            "question-3-answer-5": {
                "question-3-5-answer-1": 21,
                "question-3-5-answer-3": 23,
                "question-3-5-answer-4": 79
            },
            "question-3-answer-6": {
                "question-3-6-answer-2": 80
            }
        },
        "question-2-3-2-answer-2": {
            "question-3-answer-1": {
                "question-3-1-answer-1": 81,
                "question-3-1-answer-2": 81
            },
            "question-3-answer-2": {
                "question-3-2-answer-1": 82
            },
            "question-3-answer-3": {
                "question-3-3-answer-2": 3,
                "question-3-3-answer-3": 83,
                "question-3-3-answer-4": 76
            },
            "question-3-answer-5": {
                "question-3-5-answer-1": 21,
                "question-3-5-answer-3": 23,
                "question-3-5-answer-4": 79
            }
        },
        "question-2-4-answer-1": {
            "question-3-answer-1": {
                "question-3-1-answer-1": 84,
                "question-3-1-answer-2": 84
            },
            "question-3-answer-2": {
                "question-3-2-answer-1": 85
            },
            "question-3-answer-3": {
                "question-3-3-answer-2": 86,
                "question-3-3-answer-7": 87,
                "question-3-3-answer-9": 88,
                "question-3-3-answer-21": 89
            },
            "question-3-answer-5": {
                "question-3-5-answer-1": 21,
                "question-3-5-answer-2": 22,
                "question-3-5-answer-3": 65,
                "question-3-5-answer-4": 59
            },
            "question-3-answer-6": {
                "question-3-6-answer-2": 90
            },
            "question-3-answer-7": {
                "question-3-7-answer-2": 27
            }
        },
        "question-2-4-answer-2": {
            "question-3-answer-1": {
                "question-3-1-answer-1": 91,
                "question-3-1-answer-2": 91
            },
            "question-3-answer-2": {
                "question-3-2-answer-1": 92
            },
            "question-3-answer-3": {
                "question-3-3-answer-2": 86,
                "question-3-3-answer-7": 93,
                "question-3-3-answer-9": 94,
                "question-3-3-answer-21": 89
            },
            "question-3-answer-5": {
                "question-3-5-answer-1": 21,
                "question-3-5-answer-2": 22,
                "question-3-5-answer-3": 65,
                "question-3-5-answer-4": 59
            },
            "question-3-answer-6": {
                "question-3-6-answer-2": 90
            },
            "question-3-answer-7": {
                "question-3-7-answer-2": 27
            }
        },
        "question-2-4-answer-3": {
            "question-3-answer-1": {
                "question-3-1-answer-1": 95,
                "question-3-1-answer-2": 95
            },
            "question-3-answer-2": {
                "question-3-2-answer-1": 96
            },
            "question-3-answer-3": {
                "question-3-3-answer-2": 86,
                "question-3-3-answer-7": 96
            },
            "question-3-answer-5": {
                "question-3-5-answer-1": 21,
                "question-3-5-answer-3": 65,
                "question-3-5-answer-4": 59
            },
            "question-3-answer-6": {
                "question-3-6-answer-2": 97
            },
            "question-3-answer-7": {
                "question-3-7-answer-2": 27
            }
        },
        "question-2-5-answer-1": {
            "question-3-answer-1": {
                "question-3-1-answer-1": 98,
                "question-3-1-answer-2": 98
            },
            "question-3-answer-2": {
                "question-3-2-answer-1": 99,
                "question-3-2-answer-2": 100
            },
            "question-3-answer-3": {
                "question-3-3-answer-4": 101,
                "question-3-3-answer-5": 102,
                "question-3-3-answer-7": 103,
                "question-3-3-answer-8": 103,
                "question-3-3-answer-9": 104,
                "question-3-3-answer-10": 105,
                "question-3-3-answer-12": 106,
                "question-3-3-answer-13": 10,
                "question-3-3-answer-15": 107,
                "question-3-3-answer-16": 108,
                "question-3-3-answer-17": 109,
                "question-3-3-answer-18": 110
            },
            "question-3-answer-4": {
                "question-3-4-answer-1": 111,
                "question-3-4-answer-2": 112,
                "question-3-4-answer-3": 111,
                "question-3-4-answer-6": 113
            },
            "question-3-answer-5": {
                "question-3-5-answer-1": 114,
                "question-3-5-answer-3": 115,
                "question-3-5-answer-4": 116
            },
            "question-3-answer-6": {
                "question-3-6-answer-1": 117,
                "question-3-6-answer-2": 118
            },
            "question-3-answer-7": {
                "question-3-7-answer-1": 119,
                "question-3-7-answer-2": 120
            }
        },
        "question-2-5-answer-2": {
            "question-3-answer-1": {
                "question-3-1-answer-1": 98,
                "question-3-1-answer-2": 98
            },
            "question-3-answer-2": {
                "question-3-2-answer-1": 99,
                "question-3-2-answer-2": 100
            },
            "question-3-answer-3": {
                "question-3-3-answer-4": 101,
                "question-3-3-answer-5": 102,
                "question-3-3-answer-9": 121,
                "question-3-3-answer-10": 105,
                "question-3-3-answer-12": 106,
                "question-3-3-answer-15": 107,
                "question-3-3-answer-16": 108,
                "question-3-3-answer-17": 109,
                "question-3-3-answer-18": 110
            },
            "question-3-answer-4": {
                "question-3-4-answer-1": 111,
                "question-3-4-answer-2": 112,
                "question-3-4-answer-3": 111,
                "question-3-4-answer-6": 113
            },
            "question-3-answer-5": {
                "question-3-5-answer-1": 114,
                "question-3-5-answer-3": 115,
                "question-3-5-answer-4": 116
            },
            "question-3-answer-6": {
                "question-3-6-answer-1": 117
            },
            "question-3-answer-7": {
                "question-3-7-answer-1": 119,
                "question-3-7-answer-2": 120
            }
        },
        "question-2-5-answer-3": {
            "question-3-answer-1": {
                "question-3-1-answer-1": 98,
                "question-3-1-answer-2": 98
            },
            "question-3-answer-2": {
                "question-3-2-answer-1": 99,
                "question-3-2-answer-2": 100
            },
            "question-3-answer-3": {
                "question-3-3-answer-10": 105,
                "question-3-3-answer-13": 10
            },
            "question-3-answer-5": {
                "question-3-5-answer-1": 114,
                "question-3-5-answer-3": 115,
                "question-3-5-answer-4": 122
            },
            "question-3-answer-6": {
                "question-3-6-answer-1": 123,
                "question-3-6-answer-2": 118
            },
            "question-3-answer-7": {
                "question-3-7-answer-1": 119
            }
        },
        "question-2-5-answer-4": {
            "question-3-answer-1": {
                "question-3-1-answer-1": 98,
                "question-3-1-answer-2": 98
            },
            "question-3-answer-2": {
                "question-3-2-answer-1": 99,
                "question-3-2-answer-2": 100
            },
            "question-3-answer-3": {
                "question-3-3-answer-10": 105,
                "question-3-3-answer-13": 10
            },
            "question-3-answer-5": {
                "question-3-5-answer-1": 114,
                "question-3-5-answer-3": 115,
                "question-3-5-answer-4": 116
            },
            "question-3-answer-6": {
                "question-3-6-answer-1": 117,
                "question-3-6-answer-2": 118
            },
            "question-3-answer-7": {
                "question-3-7-answer-1": 119
            }
        },
        "question-2-6-1-answer-1": {
            "question-3-answer-1": {
                "question-3-1-answer-1": 124,
                "question-3-1-answer-2": 125
            },
            "question-3-answer-2": {
                "question-3-2-answer-1": 126,
                "question-3-2-answer-2": 127
            },
            "question-3-answer-3": {
                "question-3-3-answer-2": 128,
                "question-3-3-answer-4": 129,
                "question-3-3-answer-6": 130,
                "question-3-3-answer-9": 9,
                "question-3-3-answer-10": 131,
                "question-3-3-answer-12": 132,
                "question-3-3-answer-21": 133
            },
            "question-3-answer-4": {
                "question-3-4-answer-5": 134,
                "question-3-4-answer-6": 135
            },
            "question-3-answer-5": {
                "question-3-5-answer-1": 136,
                "question-3-5-answer-2": 137,
                "question-3-5-answer-3": 138
            },
            "question-3-answer-6": {
                "question-3-6-answer-2": 139
            },
            "question-3-answer-7": {
                "question-3-7-answer-2": 140
            }
        },
        "question-2-6-1-answer-2": {
            "question-3-answer-1": {
                "question-3-1-answer-1": 141,
                "question-3-1-answer-2": 125
            },
            "question-3-answer-2": {
                "question-3-2-answer-1": 142
            },
            "question-3-answer-3": {
                "question-3-3-answer-2": 143,
                "question-3-3-answer-9": 9,
                "question-3-3-answer-10": 131,
                "question-3-3-answer-21": 133
            },
            "question-3-answer-5": {
                "question-3-5-answer-1": 136,
                "question-3-5-answer-2": 137,
                "question-3-5-answer-3": 138
            }
        },
        "question-2-6-1-answer-3": {
            "question-3-answer-1": {
                "question-3-1-answer-1": 144,
                "question-3-1-answer-2": 144
            },
            "question-3-answer-2": {
                "question-3-2-answer-1": 145,
                "question-3-2-answer-2": 146
            },
            "question-3-answer-3": {
                "question-3-3-answer-2": 147,
                "question-3-3-answer-4": 129,
                "question-3-3-answer-5": 148,
                "question-3-3-answer-8": 149,
                "question-3-3-answer-9": 9,
                "question-3-3-answer-10": 131,
                "question-3-3-answer-21": 133
            },
            "question-3-answer-4": {
                "question-3-4-answer-1": 111,
                "question-3-4-answer-5": 134
            },
            "question-3-answer-5": {
                "question-3-5-answer-1": 136,
                "question-3-5-answer-2": 137,
                "question-3-5-answer-3": 138
            }
        },
        "question-2-6-2-answer-1": {
            "question-3-answer-1": {
                "question-3-1-answer-1": 150,
                "question-3-1-answer-2": 151
            },
            "question-3-answer-2": {
                "question-3-2-answer-1": 152,
                "question-3-2-answer-2": 153
            },
            "question-3-answer-3": {
                "question-3-3-answer-2": 63,
                "question-3-3-answer-4": 129,
                "question-3-3-answer-10": 154,
                "question-3-3-answer-16": 155
            },
            "question-3-answer-4": {
                "question-3-4-answer-1": 111,
                "question-3-4-answer-2": 156,
                "question-3-4-answer-3": 157,
                "question-3-4-answer-4": 158,
                "question-3-4-answer-6": 159
            },
            "question-3-answer-5": {
                "question-3-5-answer-1": 136,
                "question-3-5-answer-2": 137,
                "question-3-5-answer-3": 138,
                "question-3-5-answer-4": 160
            },
            "question-3-answer-7": {
                "question-3-7-answer-1": 27
            }
        },
        "question-2-6-2-answer-2": {
            "question-3-answer-1": {
                "question-3-1-answer-1": 161,
                "question-3-1-answer-2": 162
            },
            "question-3-answer-2": {
                "question-3-2-answer-1": 152
            },
            "question-3-answer-3": {
                "question-3-3-answer-2": 163,
                "question-3-3-answer-4": 129,
                "question-3-3-answer-10": 164
            },
            "question-3-answer-4": {
                "question-3-4-answer-2": 165,
                "question-3-4-answer-3": 157,
                "question-3-4-answer-4": 166,
                "question-3-4-answer-6": 159
            },
            "question-3-answer-5": {
                "question-3-5-answer-1": 136,
                "question-3-5-answer-2": 137
            }
        },
        "question-2-7-answer-1": {
            "question-3-answer-1": {
                "question-3-1-answer-1": 167,
                "question-3-1-answer-2": 167
            },
            "question-3-answer-2": {
                "question-3-2-answer-1": 168
            },
            "question-3-answer-3": {
                "question-3-3-answer-2": 169,
                "question-3-3-answer-3": 170,
                "question-3-3-answer-4": 171,
                "question-3-3-answer-5": 102,
                "question-3-3-answer-7": 172,
                "question-3-3-answer-8": 173,
                "question-3-3-answer-10": 174
            }
        },
        "question-2-7-answer-2": {
            "question-3-answer-1": {
                "question-3-1-answer-1": 175,
                "question-3-1-answer-2": 175
            },
            "question-3-answer-2": {
                "question-3-2-answer-1": 176
            },
            "question-3-answer-3": {
                "question-3-3-answer-2": 177,
                "question-3-3-answer-3": 178,
                "question-3-3-answer-4": 171,
                "question-3-3-answer-5": 102,
                "question-3-3-answer-7": 179
            }
        },
        "question-2-8-answer-1": {
            "question-3-answer-1": {
                "question-3-1-answer-1": 180,
                "question-3-1-answer-2": 181
            },
            "question-3-answer-2": {
                "question-3-2-answer-1": 182,
                "question-3-2-answer-2": 183
            },
            "question-3-answer-3": {
                "question-3-3-answer-2": 3,
                "question-3-3-answer-3": 184,
                "question-3-3-answer-4": 185,
                "question-3-3-answer-5": 102,
                "question-3-3-answer-7": 186,
                "question-3-3-answer-8": 186,
                "question-3-3-answer-9": 187,
                "question-3-3-answer-10": 105,
                "question-3-3-answer-12": 106,
                "question-3-3-answer-13": 10,
                "question-3-3-answer-15": 188,
                "question-3-3-answer-17": 109,
                "question-3-3-answer-18": 110,
                "question-3-3-answer-19": 186,
                "question-3-3-answer-21": 189
            },
            "question-3-answer-4": {
                "question-3-4-answer-1": 111,
                "question-3-4-answer-2": 112,
                "question-3-4-answer-3": 111,
                "question-3-4-answer-4": 18,
                "question-3-4-answer-5": 190,
                "question-3-4-answer-6": 113
            },
            "question-3-answer-5": {
                "question-3-5-answer-1": 114,
                "question-3-5-answer-2": 22,
                "question-3-5-answer-3": 115,
                "question-3-5-answer-4": 116
            },
            "question-3-answer-6": {
                "question-3-6-answer-1": 117,
                "question-3-6-answer-2": 191
            },
            "question-3-answer-7": {
                "question-3-7-answer-1": 119,
                "question-3-7-answer-2": 120
            }
        },
        "question-2-9-answer-1": {
            "question-3-answer-1": {
                "question-3-1-answer-1": 192,
                "question-3-1-answer-2": 193
            },
            "question-3-answer-2": {
                "question-3-2-answer-1": 194,
                "question-3-2-answer-2": 195
            },
            "question-3-answer-3": {
                "question-3-3-answer-3": 196
            },
            "question-3-answer-4": {
                "question-3-4-answer-5": 197
            }
        },
        "question-2-9-answer-2": {
            "question-3-answer-1": {
                "question-3-1-answer-1": 198,
                "question-3-1-answer-2": 199
            },
            "question-3-answer-2": {
                "question-3-2-answer-1": 200
            },
            "question-3-answer-3": {
                "question-3-3-answer-3": 196
            }
        },
        "question-2-9-answer-3": {
            "question-3-answer-1": {
                "question-3-1-answer-1": 192,
                "question-3-1-answer-2": 193
            },
            "question-3-answer-2": {
                "question-3-2-answer-1": 194
            },
            "question-3-answer-3": {
                "question-3-3-answer-3": 196,
                "question-3-3-answer-7": 201
            },
            "question-3-answer-4": {
                "question-3-4-answer-2": 202
            }
        },
        "question-2-10-answer-1": {
            "question-3-answer-2": {
                "question-3-2-answer-2": 153
            },
            "question-3-answer-3": {
                "question-3-3-answer-12": 203,
                "question-3-3-answer-15": 204,
                "question-3-3-answer-16": 108,
                "question-3-3-answer-17": 109,
                "question-3-3-answer-18": 110,
                "question-3-3-answer-19": 205
            },
            "question-3-answer-4": {
                "question-3-4-answer-1": 111,
                "question-3-4-answer-2": 112,
                "question-3-4-answer-3": 111,
                "question-3-4-answer-4": 18,
                "question-3-4-answer-6": 113
            }
        },
        "question-2-10-answer-2": {
            "question-3-answer-1": {
                "question-3-1-answer-1": 206,
                "question-3-1-answer-2": 207
            },
            "question-3-answer-2": {
                "question-3-2-answer-2": 208
            },
            "question-3-answer-3": {
                "question-3-3-answer-2": 3,
                "question-3-3-answer-3": 209,
                "question-3-3-answer-4": 210,
                "question-3-3-answer-5": 102,
                "question-3-3-answer-6": 211,
                "question-3-3-answer-7": 212,
                "question-3-3-answer-8": 213,
                "question-3-3-answer-12": 106,
                "question-3-3-answer-15": 204,
                "question-3-3-answer-16": 108,
                "question-3-3-answer-17": 109,
                "question-3-3-answer-18": 110,
                "question-3-3-answer-19": 214,
                "question-3-3-answer-21": 29,
                "question-3-3-answer-22": 215
            },
            "question-3-answer-5": {
                "question-3-5-answer-1": 216,
                "question-3-5-answer-2": 217,
                "question-3-5-answer-3": 23,
                "question-3-5-answer-4": 79
            },
            "question-3-answer-6": {
                "question-3-6-answer-1": 34,
                "question-3-6-answer-2": 35
            },
            "question-3-answer-7": {
                "question-3-7-answer-1": 27,
                "question-3-7-answer-2": 120
            }
        }
    },
    "failure_modes": {
        "2.1": {
            "title": "Mechanical Failures: The part cracks or breaks",
            "image": "/assets/questions/mechanical-failure.jpg",
            "question": "What is the type of the failure?",
            "id": "2.1",
            "M_row": -1,
            "M_column": -1,
            "M_parent_id": "2",
            "sub_options": [
                {
                    "title": "Short term mechanical failures",
                    "image": "",
                    "question": "What failure mode applies best to your situation?",
                    "id": "2.1.1",
                    "M_row": -1,
                    "M_column": -1,
                    "M_parent_id": "2.1",
                    "sub_options": [
                        {
                            "title": "Failure due to static overload (short term)",
                            "image": "",
                            "question": "",
                            "id": "2.1.1.1",
                            "M_row": 4,
                            "M_column": -1,
                            "M_parent_id": "2.1.1",
                            "sub_options": []
                        },
                        {
                            "title": "Failure due to dynamic loading (impact, vibration)",
                            "image": "",
                            "question": "",
                            "id": "2.1.1.2",
                            "M_row": 5,
                            "M_column": -1,
                            "M_parent_id": "2.1.1",
                            "sub_options": []
                        }
                    ]
                },
                {
                    "title": "Long term mechanical failures",
                    "image": "",
                    "question": "What failure mode applies best to your situation?",
                    "id": "2.1.2",
                    "M_row": -1,
                    "M_column": -1,
                    "M_parent_id": "2.1",
                    "sub_options": [
                        {
                            "title": "Failure due to repetitive loading (fatigue, mid-long term)",
                            "image": "",
                            "question": "",
                            "id": "2.1.2.1",
                            "M_row": 6,
                            "M_column": -1,
                            "M_parent_id": "2.1.2",
                            "sub_options": []
                        },
                        {
                            "title": "Failure due to static overload (creep, long term)",
                            "image": "",
                            "question": "",
                            "id": "2.1.2.2",
                            "M_row": 7,
                            "M_column": -1,
                            "M_parent_id": "2.1.2",
                            "sub_options": []
                        },
                        {
                            "title": "Failure caused by environmental effects (temperature, chemical, moisture, UV)",
                            "image": "",
                            "question": "",
                            "id": "2.1.2.3",
                            "M_row": 8,
                            "M_column": -1,
                            "M_parent_id": "2.1.2",
                            "sub_options": []
                        }
                    ]
                }
            ]
        },
        "2.2": {
            "title": "Dimensional Failures: Out of required dimensional accuracy",
            "image": "/assets/questions/dimension-failure.jpg",
            "question": "What is the type of the failure?",
            "id": "2.2",
            "M_row": -1,
            "M_column": -1,
            "M_parent_id": "2",
            "sub_options": [
                {
                    "title": "Reversible dimensional failures",
                    "image": "",
                    "question": "What failure mode applies best to your situation?",
                    "id": "2.2.1",
                    "M_row": -1,
                    "M_column": -1,
                    "M_parent_id": "2.2",
                    "sub_options": [
                        {
                            "title": "Excessive elastic deformation under load",
                            "image": "",
                            "question": "",
                            "id": "2.2.1.1",
                            "M_row": 10,
                            "M_column": -1,
                            "M_parent_id": "2.2.1",
                            "sub_options": []
                        },
                        {
                            "title": "Excessive environmental influence on dimensions (temperature, chemicals, moisture)",
                            "image": "",
                            "question": "",
                            "id": "2.2.1.2",
                            "M_row": 11,
                            "M_column": -1,
                            "M_parent_id": "2.2.1",
                            "sub_options": []
                        }
                    ]
                },
                {
                    "title": "Permanent dimensional failures",
                    "image": "",
                    "question": "What failure mode applies best to your situation?",
                    "id": "2.2.2",
                    "M_row": -1,
                    "M_column": -1,
                    "M_parent_id": "2.2",
                    "sub_options": [
                        {
                            "title": "Incorrect initial part accuracy",
                            "image": "",
                            "question": "",
                            "id": "2.2.2.1",
                            "M_row": 12,
                            "M_column": -1,
                            "M_parent_id": "2.2.2",
                            "sub_options": []
                        },
                        {
                            "title": "Excessive plastic deformation under load (short term/ long term)",
                            "image": "",
                            "question": "",
                            "id": "2.2.2.2",
                            "M_row": 13,
                            "M_column": -1,
                            "M_parent_id": "2.2.2",
                            "sub_options": []
                        },
                        {
                            "title": "Excessive wear",
                            "image": "",
                            "question": "",
                            "id": "2.2.2.3",
                            "M_row": 14,
                            "M_column": -1,
                            "M_parent_id": "2.2.2",
                            "sub_options": []
                        }
                    ]
                }
            ]
        },
        "2.3": {
            "title": "Electrical and/or Electromagnetic Failures",
            "image": "/assets/questions/electromagnetic-failure.jpg",
            "question": "What is the type of the failure?",
            "id": "2.3",
            "M_row": -1,
            "M_column": -1,
            "M_parent_id": "2",
            "sub_options": [
                {
                    "title": "Incorrect insulation behaviour\n(e.g. short circuit, insulation)",
                    "image": "",
                    "question": "What failure mode applies best to your situation?",
                    "id": "2.3.1",
                    "M_row": -1,
                    "M_column": -1,
                    "M_parent_id": "2.3",
                    "sub_options": [
                        {
                            "title": "Undesired short circuit",
                            "image": "",
                            "question": "",
                            "id": "2.3.1.1",
                            "M_row": 16,
                            "M_column": -1,
                            "M_parent_id": "2.3.1",
                            "sub_options": []
                        },
                        {
                            "title": "Electro corrosion of metallic neighbouring parts",
                            "image": "",
                            "question": "",
                            "id": "2.3.1.2",
                            "M_row": 17,
                            "M_column": -1,
                            "M_parent_id": "2.3.1",
                            "sub_options": []
                        }
                    ]
                },
                {
                    "title": "Incorrect electromagnetic behaviour\n(e.g. reflection, absorption, transmission)",
                    "image": "",
                    "question": "What failure mode applies best to your situation?",
                    "id": "2.3.2",
                    "M_row": -1,
                    "M_column": -1,
                    "M_parent_id": "2.3",
                    "sub_options": [
                        {
                            "title": "Insufficient EMI-shielding",
                            "image": "",
                            "question": "",
                            "id": "2.3.2.1",
                            "M_row": 18,
                            "M_column": -1,
                            "M_parent_id": "2.3.2",
                            "sub_options": []
                        },
                        {
                            "title": "Undesirable blocking of signals",
                            "image": "",
                            "question": "",
                            "id": "2.3.2.2",
                            "M_row": 19,
                            "M_column": -1,
                            "M_parent_id": "2.3.2",
                            "sub_options": []
                        }
                    ]
                }
            ]
        },
        "2.4": {
            "title": "Thermal Failures",
            "image": "/assets/questions/thermal-failure.jpg",
            "question": "What is the type of the failure?",
            "id": "2.4",
            "M_row": -1,
            "M_column": -1,
            "M_parent_id": "2",
            "sub_options": [
                {
                    "title": "Temperature leading to failure of internals/ surroundings",
                    "image": "",
                    "question": "",
                    "id": "2.4.1",
                    "M_row": 21,
                    "M_column": -1,
                    "M_parent_id": "2.4",
                    "sub_options": []
                },
                {
                    "title": "Temperature leading to accelerated ageing of material",
                    "image": "",
                    "question": "",
                    "id": "2.4.2",
                    "M_row": 22,
                    "M_column": -1,
                    "M_parent_id": "2.4",
                    "sub_options": []
                },
                {
                    "title": "Part catches fire",
                    "image": "",
                    "question": "",
                    "id": "2.4.3",
                    "M_row": 23,
                    "M_column": -1,
                    "M_parent_id": "2.4",
                    "sub_options": []
                }
            ]
        },
        "2.5": {
            "title": "Aesthetic Failures",
            "image": "/assets/questions/aesthetics-failure.jpg",
            "question": "What is the type of the failure?",
            "id": "2.5",
            "M_row": -1,
            "M_column": -1,
            "M_parent_id": "2",
            "sub_options": [
                {
                    "title": "Surface defects",
                    "image": "",
                    "question": "",
                    "id": "2.5.1",
                    "M_row": 25,
                    "M_column": -1,
                    "M_parent_id": "2.5",
                    "sub_options": []
                },
                {
                    "title": "Discoloration",
                    "image": "",
                    "question": "",
                    "id": "2.5.2",
                    "M_row": 26,
                    "M_column": -1,
                    "M_parent_id": "2.5",
                    "sub_options": []
                },
                {
                    "title": "Scratches",
                    "image": "",
                    "question": "",
                    "id": "2.5.3",
                    "M_row": 27,
                    "M_column": -1,
                    "M_parent_id": "2.5",
                    "sub_options": []
                },
                {
                    "title": "Wear marks",
                    "image": "",
                    "question": "",
                    "id": "2.5.4",
                    "M_row": 28,
                    "M_column": -1,
                    "M_parent_id": "2.5",
                    "sub_options": []
                }
            ]
        },
        "2.6": {
            "title": "Wear and/or Friction Failures",
            "image": "/assets/questions/wear-friction-failure.png",
            "question": "What is the type of the failure?",
            "id": "2.6",
            "M_row": -1,
            "M_column": -1,
            "M_parent_id": "2",
            "sub_options": [
                {
                    "title": "Incorrect friction behaviour",
                    "image": "",
                    "question": "What failure mode applies best to your situation?",
                    "id": "2.6.1",
                    "M_row": -1,
                    "M_column": -1,
                    "M_parent_id": "2.6",
                    "sub_options": [
                        {
                            "title": "Incorrect power consumption",
                            "image": "",
                            "question": "",
                            "id": "2.6.1.1",
                            "M_row": 30,
                            "M_column": -1,
                            "M_parent_id": "2.6.1",
                            "sub_options": []
                        },
                        {
                            "title": "Increased thermal loading",
                            "image": "",
                            "question": "",
                            "id": "2.6.1.2",
                            "M_row": 31,
                            "M_column": -1,
                            "M_parent_id": "2.6.1",
                            "sub_options": []
                        },
                        {
                            "title": "Incorrect dynamic response (slip-stick or jamming)",
                            "image": "",
                            "question": "",
                            "id": "2.6.1.3",
                            "M_row": 32,
                            "M_column": -1,
                            "M_parent_id": "2.6.1",
                            "sub_options": []
                        }
                    ]
                },
                {
                    "title": "Incorrect wear behaviour",
                    "image": "",
                    "question": "What failure mode applies best to your situation?",
                    "id": "2.6.2",
                    "M_row": -1,
                    "M_column": -1,
                    "M_parent_id": "2.6",
                    "sub_options": [
                        {
                            "title": "Excessive wear",
                            "image": "",
                            "question": "",
                            "id": "2.6.2.1",
                            "M_row": 33,
                            "M_column": -1,
                            "M_parent_id": "2.6.2",
                            "sub_options": []
                        },
                        {
                            "title": "Formation of debris",
                            "image": "",
                            "question": "",
                            "id": "2.6.2.2",
                            "M_row": 34,
                            "M_column": -1,
                            "M_parent_id": "2.6.2",
                            "sub_options": []
                        }
                    ]
                }
            ]
        },
        "2.7": {
            "title": "Failure due to Noise, Vibration or Harshness",
            "image": "/assets/questions/noice-failure.jpg",
            "question": "What is the type of the failure?",
            "id": "2.7",
            "M_row": -1,
            "M_column": -1,
            "M_parent_id": "2",
            "sub_options": [
                {
                    "title": "Acoustic behaviour not meeting specification",
                    "image": "",
                    "question": "",
                    "id": "2.7.1",
                    "M_row": 36,
                    "M_column": -1,
                    "M_parent_id": "2.7",
                    "sub_options": []
                },
                {
                    "title": "Part resonance frequency not meeting expected level",
                    "image": "",
                    "question": "",
                    "id": "2.7.2",
                    "M_row": 37,
                    "M_column": -1,
                    "M_parent_id": "2.7",
                    "sub_options": []
                }
            ]
        },
        "2.8": {
            "title": "Functional Capability Failures",
            "image": "/assets/questions/functioning-failure.jpg",
            "question": "What is the type of the failure?",
            "id": "2.8",
            "M_row": -1,
            "M_column": -1,
            "M_parent_id": "2",
            "sub_options": [
                {
                    "title": "Loss of sealing functionality",
                    "image": "",
                    "question": "",
                    "id": "2.8.1",
                    "M_row": 39,
                    "M_column": -1,
                    "M_parent_id": "2.8",
                    "sub_options": []
                }
            ]
        },
        "2.9": {
            "title": "Legal Requirement Violations",
            "image": "/assets/questions/legal-failure.jpg",
            "question": "What is the type of the failure?",
            "id": "2.9",
            "M_row": -1,
            "M_column": -1,
            "M_parent_id": "2",
            "sub_options": [
                {
                    "title": "Food approval is violated",
                    "image": "",
                    "question": "",
                    "id": "2.9.1",
                    "M_row": 41,
                    "M_column": -1,
                    "M_parent_id": "2.9",
                    "sub_options": []
                },
                {
                    "title": "Chemical Compliance Regulations (such as REACH) are violated",
                    "image": "",
                    "question": "",
                    "id": "2.9.2",
                    "M_row": 42,
                    "M_column": -1,
                    "M_parent_id": "2.9",
                    "sub_options": []
                },
                {
                    "title": "Flammability requirements not met",
                    "image": "",
                    "question": "",
                    "id": "2.9.3",
                    "M_row": 43,
                    "M_column": -1,
                    "M_parent_id": "2.9",
                    "sub_options": []
                }
            ]
        },
        "2.10": {
            "title": "Production and/or Assembly Failures",
            "image": "/assets/questions/production-assembly-failure.jpg",
            "question": "What is the type of the failure?",
            "id": "2.10",
            "M_row": -1,
            "M_column": -1,
            "M_parent_id": "2",
            "sub_options": [
                {
                    "title": "Not producable with intended production process",
                    "image": "",
                    "question": "",
                    "id": "2.10.1",
                    "M_row": 45,
                    "M_column": -1,
                    "M_parent_id": "2.10",
                    "sub_options": []
                },
                {
                    "title": "Part (dis)assembly not possible with intended production process (screwing / clicking / welding / glueing / other)",
                    "image": "",
                    "question": "",
                    "id": "2.10.2",
                    "M_row": 46,
                    "M_column": -1,
                    "M_parent_id": "2.10",
                    "sub_options": []
                }
            ]
        }
    },
    "project_phases": {
        "3.1": {
            "title": "Definition of specifications (part requirements)",
            "image": "/assets/questions/phase-definition-specification.jpg",
            "question": "",
            "id": "3.1",
            "M_row": -1,
            "M_column": -1,
            "M_parent_id": "-1",
            "sub_options": [
                {
                    "title": "Not all real-use requirements are taken into account, when defining the part specifications (e.g. metal vs. plastic)",
                    "image": "/assets/questions/phase-definition-specification.jpg",
                    "question": "",
                    "id": "3.1.1",
                    "M_row": -1,
                    "M_column": 5,
                    "M_parent_id": "3.1",
                    "sub_options": [],
                    "M_parent_answer_id": "question-3-answer-1"
                },
                {
                    "title": "Defined part requirements are not accurately reflecting the real in-use condions",
                    "image": "/assets/questions/phase-choice-material.jpg",
                    "question": "",
                    "id": "3.1.2",
                    "M_row": -1,
                    "M_column": 6,
                    "M_parent_id": "3.1",
                    "sub_options": [],
                    "M_parent_answer_id": "question-3-answer-1"
                }
            ]
        },
        "3.2": {
            "title": "Selection of material",
            "image": "/assets/questions/phase-choice-material.jpg",
            "question": "",
            "id": "3.2",
            "M_row": -1,
            "M_column": -1,
            "M_parent_id": "-1",
            "sub_options": [
                {
                    "title": "Selected material does not fulfill required properties",
                    "image": "/assets/questions/phase-definition-specification.jpg",
                    "question": "",
                    "id": "3.2.1",
                    "M_row": -1,
                    "M_column": 8,
                    "M_parent_id": "3.2",
                    "sub_options": [],
                    "M_parent_answer_id": "question-3-answer-2"
                },
                {
                    "title": "Not all part manufacturing requirements are considered properly",
                    "image": "/assets/questions/phase-choice-material.jpg",
                    "question": "",
                    "id": "3.2.2",
                    "M_row": -1,
                    "M_column": 9,
                    "M_parent_id": "3.2",
                    "sub_options": [],
                    "M_parent_answer_id": "question-3-answer-2"
                }
            ]
        },
        "3.3": {
            "title": "Design process",
            "image": "/assets/questions/phase-design-process.jpg",
            "question": "",
            "id": "3.3",
            "M_row": -1,
            "M_column": -1,
            "M_parent_id": "-1",
            "sub_options": [
                {
                    "title": "Design for part funtionality",
                    "image": "/assets/questions/phase-definition-specification.jpg",
                    "question": "",
                    "id": "3.3.1",
                    "M_row": -1,
                    "M_column": 11,
                    "M_parent_id": "3.3",
                    "sub_options": [],
                    "M_parent_answer_id": "question-3-answer-3"
                },
                {
                    "title": "Incorrectly simulated prediction of functional capability (mesh resolution, material model, fibre orientation, etc)",
                    "image": "/assets/questions/phase-choice-material.jpg",
                    "question": "",
                    "id": "3.3.2",
                    "M_row": -1,
                    "M_column": 12,
                    "M_parent_id": "3.3",
                    "sub_options": [],
                    "M_parent_answer_id": "question-3-answer-3"
                },
                {
                    "title": "Wrong inserts selected",
                    "image": "/assets/questions/phase-design-process.jpg",
                    "question": "",
                    "id": "3.3.3",
                    "M_row": -1,
                    "M_column": 13,
                    "M_parent_id": "3.3",
                    "sub_options": [],
                    "M_parent_answer_id": "question-3-answer-3"
                },
                {
                    "title": "Local orientation of fibre-reinforcement is not optimal (glassfiber, carbonfiber, etc.)",
                    "image": "/assets/questions/phase-manufacturing.jpg",
                    "question": "",
                    "id": "3.3.4",
                    "M_row": -1,
                    "M_column": 14,
                    "M_parent_id": "3.3",
                    "sub_options": [],
                    "M_parent_answer_id": "question-3-answer-3"
                },
                {
                    "title": "Weld line at critical location",
                    "image": "/assets/questions/phase-validation.png",
                    "question": "",
                    "id": "3.3.5",
                    "M_row": -1,
                    "M_column": 15,
                    "M_parent_id": "3.3",
                    "sub_options": [],
                    "M_parent_answer_id": "question-3-answer-3"
                },
                {
                    "title": "Incorrect edge radii (stress concentration)",
                    "image": "/assets/questions/phase-assembly.jpg",
                    "question": "",
                    "id": "3.3.6",
                    "M_row": -1,
                    "M_column": 16,
                    "M_parent_id": "3.3",
                    "sub_options": [],
                    "M_parent_answer_id": "question-3-answer-3"
                },
                {
                    "title": "Incorrect wall thickness",
                    "image": "/assets/questions/phase-actual.png",
                    "question": "",
                    "id": "3.3.7",
                    "M_row": -1,
                    "M_column": 17,
                    "M_parent_id": "3.3",
                    "sub_options": [],
                    "M_parent_answer_id": "question-3-answer-3"
                },
                {
                    "title": "Ineffective ribbing",
                    "image": "/assets/questions/phase-definition-specification.jpg",
                    "question": "",
                    "id": "3.3.8",
                    "M_row": -1,
                    "M_column": 18,
                    "M_parent_id": "3.3",
                    "sub_options": [],
                    "M_parent_answer_id": "question-3-answer-3"
                },
                {
                    "title": "Ineffective heat dissipation features (cooling ribs, contact with heatsinks)",
                    "image": "/assets/questions/phase-choice-material.jpg",
                    "question": "",
                    "id": "3.3.9",
                    "M_row": -1,
                    "M_column": 19,
                    "M_parent_id": "3.3",
                    "sub_options": [],
                    "M_parent_answer_id": "question-3-answer-3"
                },
                {
                    "title": "Contact pressure and/or contact speed outside of capability limits",
                    "image": "/assets/questions/phase-design-process.jpg",
                    "question": "",
                    "id": "3.3.10",
                    "M_row": -1,
                    "M_column": 20,
                    "M_parent_id": "3.3",
                    "sub_options": [],
                    "M_parent_answer_id": "question-3-answer-3"
                },
                {
                    "title": "Design for Manufacturing",
                    "image": "/assets/questions/phase-manufacturing.jpg",
                    "question": "",
                    "id": "3.3.11",
                    "M_row": -1,
                    "M_column": 21,
                    "M_parent_id": "3.3",
                    "sub_options": [],
                    "M_parent_answer_id": "question-3-answer-3"
                },
                {
                    "title": "Design not optimized for Injection Molding in combination with secondary operations",
                    "image": "/assets/questions/phase-validation.png",
                    "question": "",
                    "id": "3.3.12",
                    "M_row": -1,
                    "M_column": 22,
                    "M_parent_id": "3.3",
                    "sub_options": [],
                    "M_parent_answer_id": "question-3-answer-3"
                },
                {
                    "title": "Insufficient release angle",
                    "image": "/assets/questions/phase-assembly.jpg",
                    "question": "",
                    "id": "3.3.13",
                    "M_row": -1,
                    "M_column": 23,
                    "M_parent_id": "3.3",
                    "sub_options": [],
                    "M_parent_answer_id": "question-3-answer-3"
                },
                {
                    "title": "Mold design (for warpage, venting, Gas Counter Pressure etc.)",
                    "image": "/assets/questions/phase-actual.png",
                    "question": "",
                    "id": "3.3.14",
                    "M_row": -1,
                    "M_column": 24,
                    "M_parent_id": "3.3",
                    "sub_options": [],
                    "M_parent_answer_id": "question-3-answer-3"
                },
                {
                    "title": "Gate locations chosen wrongly",
                    "image": "/assets/questions/phase-definition-specification.jpg",
                    "question": "",
                    "id": "3.3.15",
                    "M_row": -1,
                    "M_column": 25,
                    "M_parent_id": "3.3",
                    "sub_options": [],
                    "M_parent_answer_id": "question-3-answer-3"
                },
                {
                    "title": "Gate dimensions and runner system inadequate",
                    "image": "/assets/questions/phase-choice-material.jpg",
                    "question": "",
                    "id": "3.3.16",
                    "M_row": -1,
                    "M_column": 26,
                    "M_parent_id": "3.3",
                    "sub_options": [],
                    "M_parent_answer_id": "question-3-answer-3"
                },
                {
                    "title": "Inadequate mold venting",
                    "image": "/assets/questions/phase-design-process.jpg",
                    "question": "",
                    "id": "3.3.17",
                    "M_row": -1,
                    "M_column": 27,
                    "M_parent_id": "3.3",
                    "sub_options": [],
                    "M_parent_answer_id": "question-3-answer-3"
                },
                {
                    "title": "Inadequate cooling channel placement",
                    "image": "/assets/questions/phase-manufacturing.jpg",
                    "question": "",
                    "id": "3.3.18",
                    "M_row": -1,
                    "M_column": 28,
                    "M_parent_id": "3.3",
                    "sub_options": [],
                    "M_parent_answer_id": "question-3-answer-3"
                },
                {
                    "title": "Insufficient coring out",
                    "image": "/assets/questions/phase-validation.png",
                    "question": "",
                    "id": "3.3.19",
                    "M_row": -1,
                    "M_column": 29,
                    "M_parent_id": "3.3",
                    "sub_options": [],
                    "M_parent_answer_id": "question-3-answer-3"
                },
                {
                    "title": "Design for assembly or dis-assembly",
                    "image": "/assets/questions/phase-assembly.jpg",
                    "question": "",
                    "id": "3.3.20",
                    "M_row": -1,
                    "M_column": 30,
                    "M_parent_id": "3.3",
                    "sub_options": [],
                    "M_parent_answer_id": "question-3-answer-3"
                },
                {
                    "title": "Thermal expansion differences between parts not sufficiently considered",
                    "image": "/assets/questions/phase-actual.png",
                    "question": "",
                    "id": "3.3.21",
                    "M_row": -1,
                    "M_column": 31,
                    "M_parent_id": "3.3",
                    "sub_options": [],
                    "M_parent_answer_id": "question-3-answer-3"
                },
                {
                    "title": "Assembly sequence and/or constraints not sufficiently considered",
                    "image": "/assets/questions/phase-definition-specification.jpg",
                    "question": "",
                    "id": "3.3.22",
                    "M_row": -1,
                    "M_column": 32,
                    "M_parent_id": "3.3",
                    "sub_options": [],
                    "M_parent_answer_id": "question-3-answer-3"
                }
            ]
        },
        "3.4": {
            "title": "Part manufacturing (focus on injection molding)",
            "image": "/assets/questions/phase-manufacturing.jpg",
            "question": "",
            "id": "3.4",
            "M_row": -1,
            "M_column": -1,
            "M_parent_id": "-1",
            "sub_options": [
                {
                    "title": "Too high amount of volatiles in the melt,  causing blistering and/or outgassing",
                    "image": "/assets/questions/phase-definition-specification.jpg",
                    "question": "",
                    "id": "3.4.1",
                    "M_row": -1,
                    "M_column": 34,
                    "M_parent_id": "3.4",
                    "sub_options": [],
                    "M_parent_answer_id": "question-3-answer-4"
                },
                {
                    "title": "Mismatch of Mold and Injection Molding machine dimensions",
                    "image": "/assets/questions/phase-choice-material.jpg",
                    "question": "",
                    "id": "3.4.2",
                    "M_row": -1,
                    "M_column": 35,
                    "M_parent_id": "3.4",
                    "sub_options": [],
                    "M_parent_answer_id": "question-3-answer-4"
                },
                {
                    "title": "Material  dried insufficiently before processing",
                    "image": "/assets/questions/phase-design-process.jpg",
                    "question": "",
                    "id": "3.4.3",
                    "M_row": -1,
                    "M_column": 36,
                    "M_parent_id": "3.4",
                    "sub_options": [],
                    "M_parent_answer_id": "question-3-answer-4"
                },
                {
                    "title": "Actual machine values are not corresponding with chosen settings (\"Ist\" vs.\"Soll\")",
                    "image": "/assets/questions/phase-manufacturing.jpg",
                    "question": "",
                    "id": "3.4.4",
                    "M_row": -1,
                    "M_column": 37,
                    "M_parent_id": "3.4",
                    "sub_options": [],
                    "M_parent_answer_id": "question-3-answer-4"
                },
                {
                    "title": "Applied Mold-release incorrect (amount, type, compatibility with secondary operations etc.)",
                    "image": "/assets/questions/phase-validation.png",
                    "question": "",
                    "id": "3.4.5",
                    "M_row": -1,
                    "M_column": 38,
                    "M_parent_id": "3.4",
                    "sub_options": [],
                    "M_parent_answer_id": "question-3-answer-4"
                },
                {
                    "title": "Processing settings chosen outside of material-specific Injection Molding recommendations",
                    "image": "/assets/questions/phase-assembly.jpg",
                    "question": "",
                    "id": "3.4.6",
                    "M_row": -1,
                    "M_column": 39,
                    "M_parent_id": "3.4",
                    "sub_options": [],
                    "M_parent_answer_id": "question-3-answer-4"
                }
            ]
        },
        "3.5": {
            "title": "Part validation",
            "image": "/assets/questions/phase-validation.png",
            "question": "",
            "id": "3.5",
            "M_row": -1,
            "M_column": -1,
            "M_parent_id": "-1",
            "sub_options": [
                {
                    "title": "Prototype testing does not emulate critical in-use condition; conditions too harsh or too mild",
                    "image": "/assets/questions/phase-definition-specification.jpg",
                    "question": "",
                    "id": "3.5.1",
                    "M_row": -1,
                    "M_column": 41,
                    "M_parent_id": "3.5",
                    "sub_options": [],
                    "M_parent_answer_id": "question-3-answer-5"
                },
                {
                    "title": "Accelerated testing conditions (higher frequency, load, temperature, duration etc.) introduce failure modes not occurring in real life",
                    "image": "/assets/questions/phase-choice-material.jpg",
                    "question": "",
                    "id": "3.5.2",
                    "M_row": -1,
                    "M_column": 42,
                    "M_parent_id": "3.5",
                    "sub_options": [],
                    "M_parent_answer_id": "question-3-answer-5"
                },
                {
                    "title": "Incorrect execution of validation test (incorrect application of loads, environment, conditioning state, settings etc.)",
                    "image": "/assets/questions/phase-design-process.jpg",
                    "question": "",
                    "id": "3.5.3",
                    "M_row": -1,
                    "M_column": 43,
                    "M_parent_id": "3.5",
                    "sub_options": [],
                    "M_parent_answer_id": "question-3-answer-5"
                },
                {
                    "title": "Tested prototypes do not represent mass-production parts",
                    "image": "/assets/questions/phase-manufacturing.jpg",
                    "question": "",
                    "id": "3.5.4",
                    "M_row": -1,
                    "M_column": 44,
                    "M_parent_id": "3.5",
                    "sub_options": [],
                    "M_parent_answer_id": "question-3-answer-5"
                }
            ]
        },
        "3.6": {
            "title": "Assembly",
            "image": "/assets/questions/phase-assembly.jpg",
            "question": "",
            "id": "3.6",
            "M_row": -1,
            "M_column": -1,
            "M_parent_id": "-1",
            "sub_options": [
                {
                    "title": "Excessive stress during assembly",
                    "image": "/assets/questions/phase-definition-specification.jpg",
                    "question": "",
                    "id": "3.6.1",
                    "M_row": -1,
                    "M_column": 46,
                    "M_parent_id": "3.6",
                    "sub_options": [],
                    "M_parent_answer_id": "question-3-answer-6"
                },
                {
                    "title": "Dimensions outside assembly-tolerance",
                    "image": "/assets/questions/phase-choice-material.jpg",
                    "question": "",
                    "id": "3.6.2",
                    "M_row": -1,
                    "M_column": 47,
                    "M_parent_id": "3.6",
                    "sub_options": [],
                    "M_parent_answer_id": "question-3-answer-6"
                }
            ]
        },
        "3.7": {
            "title": "Actual / daily use",
            "image": "/assets/questions/phase-actual.png",
            "question": "",
            "id": "3.7",
            "M_row": -1,
            "M_column": -1,
            "M_parent_id": "-1",
            "sub_options": [
                {
                    "title": "Loads outside of specified (intended) use conditions",
                    "image": "/assets/questions/phase-definition-specification.jpg",
                    "question": "",
                    "id": "3.7.1",
                    "M_row": -1,
                    "M_column": 49,
                    "M_parent_id": "3.7",
                    "sub_options": [],
                    "M_parent_answer_id": "question-3-answer-7"
                },
                {
                    "title": "Environmental circumstances outside of specified (intended) use conditions",
                    "image": "/assets/questions/phase-choice-material.jpg",
                    "question": "",
                    "id": "3.7.2",
                    "M_row": -1,
                    "M_column": 50,
                    "M_parent_id": "3.7",
                    "sub_options": [],
                    "M_parent_answer_id": "question-3-answer-7"
                }
            ]
        }
    },
    "form_data_failure_modes": [
        {
            "id": "question-2-answer-1",
            "value": "2.1",
            "i18nDescription": "Mechanical Failures: The part cracks or breaks",
            "i18nDescriptionText": "",
            "imgUrl": "/assets/questions/mechanical-failure.jpg",
            "isSelected": false,
            "subQuestions": [
                {
                    "id": "question-2-1",
                    "questionNumber": "2.1",
                    "i18nQuestion": "What is the type of the failure?",
                    "answers": [
                        {
                            "id": "question-2-1-answer-1",
                            "value": "2.1.1",
                            "i18nDescription": "Short term mechanical failures",
                            "i18nDescriptionText": "",
                            "imgUrl": "",
                            "isSelected": false,
                            "subQuestions": [
                                {
                                    "id": "question-2-1-1",
                                    "questionNumber": "2.2",
                                    "i18nQuestion": "What failure mode applies best to your situation?",
                                    "answers": [
                                        {
                                            "id": "question-2-1-1-answer-1",
                                            "value": "2.1.1.1",
                                            "i18nDescription": "Failure due to static overload (short term)",
                                            "i18nDescriptionText": "",
                                            "imgUrl": "",
                                            "isSelected": false,
                                            "subQuestions": []
                                        },
                                        {
                                            "id": "question-2-1-1-answer-2",
                                            "value": "2.1.1.2",
                                            "i18nDescription": "Failure due to dynamic loading (impact, vibration)",
                                            "i18nDescriptionText": "",
                                            "imgUrl": "",
                                            "isSelected": false,
                                            "subQuestions": []
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "id": "question-2-1-answer-2",
                            "value": "2.1.2",
                            "i18nDescription": "Long term mechanical failures",
                            "i18nDescriptionText": "",
                            "imgUrl": "",
                            "isSelected": false,
                            "subQuestions": [
                                {
                                    "id": "question-2-1-2",
                                    "questionNumber": "2.2",
                                    "i18nQuestion": "What failure mode applies best to your situation?",
                                    "answers": [
                                        {
                                            "id": "question-2-1-2-answer-1",
                                            "value": "2.1.2.1",
                                            "i18nDescription": "Failure due to repetitive loading (fatigue, mid-long term)",
                                            "i18nDescriptionText": "",
                                            "imgUrl": "",
                                            "isSelected": false,
                                            "subQuestions": []
                                        },
                                        {
                                            "id": "question-2-1-2-answer-2",
                                            "value": "2.1.2.2",
                                            "i18nDescription": "Failure due to static overload (creep, long term)",
                                            "i18nDescriptionText": "",
                                            "imgUrl": "",
                                            "isSelected": false,
                                            "subQuestions": []
                                        },
                                        {
                                            "id": "question-2-1-2-answer-3",
                                            "value": "2.1.2.3",
                                            "i18nDescription": "Failure caused by environmental effects (temperature, chemical, moisture, UV)",
                                            "i18nDescriptionText": "",
                                            "imgUrl": "",
                                            "isSelected": false,
                                            "subQuestions": []
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "id": "question-2-answer-2",
            "value": "2.2",
            "i18nDescription": "Dimensional Failures: Out of required dimensional accuracy",
            "i18nDescriptionText": "",
            "imgUrl": "/assets/questions/dimension-failure.jpg",
            "isSelected": false,
            "subQuestions": [
                {
                    "id": "question-2-2",
                    "questionNumber": "2.1",
                    "i18nQuestion": "What is the type of the failure?",
                    "answers": [
                        {
                            "id": "question-2-2-answer-1",
                            "value": "2.2.1",
                            "i18nDescription": "Reversible dimensional failures",
                            "i18nDescriptionText": "",
                            "imgUrl": "",
                            "isSelected": false,
                            "subQuestions": [
                                {
                                    "id": "question-2-2-1",
                                    "questionNumber": "2.2",
                                    "i18nQuestion": "What failure mode applies best to your situation?",
                                    "answers": [
                                        {
                                            "id": "question-2-2-1-answer-1",
                                            "value": "2.2.1.1",
                                            "i18nDescription": "Excessive elastic deformation under load",
                                            "i18nDescriptionText": "",
                                            "imgUrl": "",
                                            "isSelected": false,
                                            "subQuestions": []
                                        },
                                        {
                                            "id": "question-2-2-1-answer-2",
                                            "value": "2.2.1.2",
                                            "i18nDescription": "Excessive environmental influence on dimensions (temperature, chemicals, moisture)",
                                            "i18nDescriptionText": "",
                                            "imgUrl": "",
                                            "isSelected": false,
                                            "subQuestions": []
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "id": "question-2-2-answer-2",
                            "value": "2.2.2",
                            "i18nDescription": "Permanent dimensional failures",
                            "i18nDescriptionText": "",
                            "imgUrl": "",
                            "isSelected": false,
                            "subQuestions": [
                                {
                                    "id": "question-2-2-2",
                                    "questionNumber": "2.2",
                                    "i18nQuestion": "What failure mode applies best to your situation?",
                                    "answers": [
                                        {
                                            "id": "question-2-2-2-answer-1",
                                            "value": "2.2.2.1",
                                            "i18nDescription": "Incorrect initial part accuracy",
                                            "i18nDescriptionText": "",
                                            "imgUrl": "",
                                            "isSelected": false,
                                            "subQuestions": []
                                        },
                                        {
                                            "id": "question-2-2-2-answer-2",
                                            "value": "2.2.2.2",
                                            "i18nDescription": "Excessive plastic deformation under load (short term/ long term)",
                                            "i18nDescriptionText": "",
                                            "imgUrl": "",
                                            "isSelected": false,
                                            "subQuestions": []
                                        },
                                        {
                                            "id": "question-2-2-2-answer-3",
                                            "value": "2.2.2.3",
                                            "i18nDescription": "Excessive wear",
                                            "i18nDescriptionText": "",
                                            "imgUrl": "",
                                            "isSelected": false,
                                            "subQuestions": []
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "id": "question-2-answer-3",
            "value": "2.3",
            "i18nDescription": "Electrical and/or Electromagnetic Failures",
            "i18nDescriptionText": "",
            "imgUrl": "/assets/questions/electromagnetic-failure.jpg",
            "isSelected": false,
            "subQuestions": [
                {
                    "id": "question-2-3",
                    "questionNumber": "2.1",
                    "i18nQuestion": "What is the type of the failure?",
                    "answers": [
                        {
                            "id": "question-2-3-answer-1",
                            "value": "2.3.1",
                            "i18nDescription": "Incorrect insulation behaviour\n(e.g. short circuit, insulation)",
                            "i18nDescriptionText": "",
                            "imgUrl": "",
                            "isSelected": false,
                            "subQuestions": [
                                {
                                    "id": "question-2-3-1",
                                    "questionNumber": "2.2",
                                    "i18nQuestion": "What failure mode applies best to your situation?",
                                    "answers": [
                                        {
                                            "id": "question-2-3-1-answer-1",
                                            "value": "2.3.1.1",
                                            "i18nDescription": "Undesired short circuit",
                                            "i18nDescriptionText": "",
                                            "imgUrl": "",
                                            "isSelected": false,
                                            "subQuestions": []
                                        },
                                        {
                                            "id": "question-2-3-1-answer-2",
                                            "value": "2.3.1.2",
                                            "i18nDescription": "Electro corrosion of metallic neighbouring parts",
                                            "i18nDescriptionText": "",
                                            "imgUrl": "",
                                            "isSelected": false,
                                            "subQuestions": []
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "id": "question-2-3-answer-2",
                            "value": "2.3.2",
                            "i18nDescription": "Incorrect electromagnetic behaviour\n(e.g. reflection, absorption, transmission)",
                            "i18nDescriptionText": "",
                            "imgUrl": "",
                            "isSelected": false,
                            "subQuestions": [
                                {
                                    "id": "question-2-3-2",
                                    "questionNumber": "2.2",
                                    "i18nQuestion": "What failure mode applies best to your situation?",
                                    "answers": [
                                        {
                                            "id": "question-2-3-2-answer-1",
                                            "value": "2.3.2.1",
                                            "i18nDescription": "Insufficient EMI-shielding",
                                            "i18nDescriptionText": "",
                                            "imgUrl": "",
                                            "isSelected": false,
                                            "subQuestions": []
                                        },
                                        {
                                            "id": "question-2-3-2-answer-2",
                                            "value": "2.3.2.2",
                                            "i18nDescription": "Undesirable blocking of signals",
                                            "i18nDescriptionText": "",
                                            "imgUrl": "",
                                            "isSelected": false,
                                            "subQuestions": []
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "id": "question-2-answer-4",
            "value": "2.4",
            "i18nDescription": "Thermal Failures",
            "i18nDescriptionText": "",
            "imgUrl": "/assets/questions/thermal-failure.jpg",
            "isSelected": false,
            "subQuestions": [
                {
                    "id": "question-2-4",
                    "questionNumber": "2.1",
                    "i18nQuestion": "What is the type of the failure?",
                    "answers": [
                        {
                            "id": "question-2-4-answer-1",
                            "value": "2.4.1",
                            "i18nDescription": "Temperature leading to failure of internals/ surroundings",
                            "i18nDescriptionText": "",
                            "imgUrl": "",
                            "isSelected": false,
                            "subQuestions": []
                        },
                        {
                            "id": "question-2-4-answer-2",
                            "value": "2.4.2",
                            "i18nDescription": "Temperature leading to accelerated ageing of material",
                            "i18nDescriptionText": "",
                            "imgUrl": "",
                            "isSelected": false,
                            "subQuestions": []
                        },
                        {
                            "id": "question-2-4-answer-3",
                            "value": "2.4.3",
                            "i18nDescription": "Part catches fire",
                            "i18nDescriptionText": "",
                            "imgUrl": "",
                            "isSelected": false,
                            "subQuestions": []
                        }
                    ]
                }
            ]
        },
        {
            "id": "question-2-answer-5",
            "value": "2.5",
            "i18nDescription": "Aesthetic Failures",
            "i18nDescriptionText": "",
            "imgUrl": "/assets/questions/aesthetics-failure.jpg",
            "isSelected": false,
            "subQuestions": [
                {
                    "id": "question-2-5",
                    "questionNumber": "2.1",
                    "i18nQuestion": "What is the type of the failure?",
                    "answers": [
                        {
                            "id": "question-2-5-answer-1",
                            "value": "2.5.1",
                            "i18nDescription": "Surface defects",
                            "i18nDescriptionText": "",
                            "imgUrl": "",
                            "isSelected": false,
                            "subQuestions": []
                        },
                        {
                            "id": "question-2-5-answer-2",
                            "value": "2.5.2",
                            "i18nDescription": "Discoloration",
                            "i18nDescriptionText": "",
                            "imgUrl": "",
                            "isSelected": false,
                            "subQuestions": []
                        },
                        {
                            "id": "question-2-5-answer-3",
                            "value": "2.5.3",
                            "i18nDescription": "Scratches",
                            "i18nDescriptionText": "",
                            "imgUrl": "",
                            "isSelected": false,
                            "subQuestions": []
                        },
                        {
                            "id": "question-2-5-answer-4",
                            "value": "2.5.4",
                            "i18nDescription": "Wear marks",
                            "i18nDescriptionText": "",
                            "imgUrl": "",
                            "isSelected": false,
                            "subQuestions": []
                        }
                    ]
                }
            ]
        },
        {
            "id": "question-2-answer-6",
            "value": "2.6",
            "i18nDescription": "Wear and/or Friction Failures",
            "i18nDescriptionText": "",
            "imgUrl": "/assets/questions/wear-friction-failure.png",
            "isSelected": false,
            "subQuestions": [
                {
                    "id": "question-2-6",
                    "questionNumber": "2.1",
                    "i18nQuestion": "What is the type of the failure?",
                    "answers": [
                        {
                            "id": "question-2-6-answer-1",
                            "value": "2.6.1",
                            "i18nDescription": "Incorrect friction behaviour",
                            "i18nDescriptionText": "",
                            "imgUrl": "",
                            "isSelected": false,
                            "subQuestions": [
                                {
                                    "id": "question-2-6-1",
                                    "questionNumber": "2.2",
                                    "i18nQuestion": "What failure mode applies best to your situation?",
                                    "answers": [
                                        {
                                            "id": "question-2-6-1-answer-1",
                                            "value": "2.6.1.1",
                                            "i18nDescription": "Incorrect power consumption",
                                            "i18nDescriptionText": "",
                                            "imgUrl": "",
                                            "isSelected": false,
                                            "subQuestions": []
                                        },
                                        {
                                            "id": "question-2-6-1-answer-2",
                                            "value": "2.6.1.2",
                                            "i18nDescription": "Increased thermal loading",
                                            "i18nDescriptionText": "",
                                            "imgUrl": "",
                                            "isSelected": false,
                                            "subQuestions": []
                                        },
                                        {
                                            "id": "question-2-6-1-answer-3",
                                            "value": "2.6.1.3",
                                            "i18nDescription": "Incorrect dynamic response (slip-stick or jamming)",
                                            "i18nDescriptionText": "",
                                            "imgUrl": "",
                                            "isSelected": false,
                                            "subQuestions": []
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "id": "question-2-6-answer-2",
                            "value": "2.6.2",
                            "i18nDescription": "Incorrect wear behaviour",
                            "i18nDescriptionText": "",
                            "imgUrl": "",
                            "isSelected": false,
                            "subQuestions": [
                                {
                                    "id": "question-2-6-2",
                                    "questionNumber": "2.2",
                                    "i18nQuestion": "What failure mode applies best to your situation?",
                                    "answers": [
                                        {
                                            "id": "question-2-6-2-answer-1",
                                            "value": "2.6.2.1",
                                            "i18nDescription": "Excessive wear",
                                            "i18nDescriptionText": "",
                                            "imgUrl": "",
                                            "isSelected": false,
                                            "subQuestions": []
                                        },
                                        {
                                            "id": "question-2-6-2-answer-2",
                                            "value": "2.6.2.2",
                                            "i18nDescription": "Formation of debris",
                                            "i18nDescriptionText": "",
                                            "imgUrl": "",
                                            "isSelected": false,
                                            "subQuestions": []
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "id": "question-2-answer-7",
            "value": "2.7",
            "i18nDescription": "Failure due to Noise, Vibration or Harshness",
            "i18nDescriptionText": "",
            "imgUrl": "/assets/questions/noice-failure.jpg",
            "isSelected": false,
            "subQuestions": [
                {
                    "id": "question-2-7",
                    "questionNumber": "2.1",
                    "i18nQuestion": "What is the type of the failure?",
                    "answers": [
                        {
                            "id": "question-2-7-answer-1",
                            "value": "2.7.1",
                            "i18nDescription": "Acoustic behaviour not meeting specification",
                            "i18nDescriptionText": "",
                            "imgUrl": "",
                            "isSelected": false,
                            "subQuestions": []
                        },
                        {
                            "id": "question-2-7-answer-2",
                            "value": "2.7.2",
                            "i18nDescription": "Part resonance frequency not meeting expected level",
                            "i18nDescriptionText": "",
                            "imgUrl": "",
                            "isSelected": false,
                            "subQuestions": []
                        }
                    ]
                }
            ]
        },
        {
            "id": "question-2-answer-8",
            "value": "2.8",
            "i18nDescription": "Functional Capability Failures",
            "i18nDescriptionText": "",
            "imgUrl": "/assets/questions/functioning-failure.jpg",
            "isSelected": false,
            "subQuestions": [
                {
                    "id": "question-2-8",
                    "questionNumber": "2.1",
                    "i18nQuestion": "What is the type of the failure?",
                    "answers": [
                        {
                            "id": "question-2-8-answer-1",
                            "value": "2.8.1",
                            "i18nDescription": "Loss of sealing functionality",
                            "i18nDescriptionText": "",
                            "imgUrl": "",
                            "isSelected": false,
                            "subQuestions": []
                        }
                    ]
                }
            ]
        },
        {
            "id": "question-2-answer-9",
            "value": "2.9",
            "i18nDescription": "Legal Requirement Violations",
            "i18nDescriptionText": "",
            "imgUrl": "/assets/questions/legal-failure.jpg",
            "isSelected": false,
            "subQuestions": [
                {
                    "id": "question-2-9",
                    "questionNumber": "2.1",
                    "i18nQuestion": "What is the type of the failure?",
                    "answers": [
                        {
                            "id": "question-2-9-answer-1",
                            "value": "2.9.1",
                            "i18nDescription": "Food approval is violated",
                            "i18nDescriptionText": "",
                            "imgUrl": "",
                            "isSelected": false,
                            "subQuestions": []
                        },
                        {
                            "id": "question-2-9-answer-2",
                            "value": "2.9.2",
                            "i18nDescription": "Chemical Compliance Regulations (such as REACH) are violated",
                            "i18nDescriptionText": "",
                            "imgUrl": "",
                            "isSelected": false,
                            "subQuestions": []
                        },
                        {
                            "id": "question-2-9-answer-3",
                            "value": "2.9.3",
                            "i18nDescription": "Flammability requirements not met",
                            "i18nDescriptionText": "",
                            "imgUrl": "",
                            "isSelected": false,
                            "subQuestions": []
                        }
                    ]
                }
            ]
        },
        {
            "id": "question-2-answer-10",
            "value": "2.10",
            "i18nDescription": "Production and/or Assembly Failures",
            "i18nDescriptionText": "",
            "imgUrl": "/assets/questions/production-assembly-failure.jpg",
            "isSelected": false,
            "subQuestions": [
                {
                    "id": "question-2-10",
                    "questionNumber": "2.1",
                    "i18nQuestion": "What is the type of the failure?",
                    "answers": [
                        {
                            "id": "question-2-10-answer-1",
                            "value": "2.10.1",
                            "i18nDescription": "Not producable with intended production process",
                            "i18nDescriptionText": "",
                            "imgUrl": "",
                            "isSelected": false,
                            "subQuestions": []
                        },
                        {
                            "id": "question-2-10-answer-2",
                            "value": "2.10.2",
                            "i18nDescription": "Part (dis)assembly not possible with intended production process (screwing / clicking / welding / glueing / other)",
                            "i18nDescriptionText": "",
                            "imgUrl": "",
                            "isSelected": false,
                            "subQuestions": []
                        }
                    ]
                }
            ]
        }
    ],
    "form_data_project_phases": {
        "question-3-answer-1": {
            "id": "question-3-answer-1",
            "value": "3.1",
            "i18nDescription": "Definition of specifications (part requirements)",
            "i18nDescriptionText": "",
            "imgUrl": "/assets/questions/phase-definition-specification.jpg",
            "isSelected": false,
            "subQuestions": []
        },
        "question-3-answer-2": {
            "id": "question-3-answer-2",
            "value": "3.2",
            "i18nDescription": "Selection of material",
            "i18nDescriptionText": "",
            "imgUrl": "/assets/questions/phase-choice-material.jpg",
            "isSelected": false,
            "subQuestions": []
        },
        "question-3-answer-3": {
            "id": "question-3-answer-3",
            "value": "3.3",
            "i18nDescription": "Design process",
            "i18nDescriptionText": "",
            "imgUrl": "/assets/questions/phase-design-process.jpg",
            "isSelected": false,
            "subQuestions": []
        },
        "question-3-answer-4": {
            "id": "question-3-answer-4",
            "value": "3.4",
            "i18nDescription": "Part manufacturing (focus on injection molding)",
            "i18nDescriptionText": "",
            "imgUrl": "/assets/questions/phase-manufacturing.jpg",
            "isSelected": false,
            "subQuestions": []
        },
        "question-3-answer-5": {
            "id": "question-3-answer-5",
            "value": "3.5",
            "i18nDescription": "Part validation",
            "i18nDescriptionText": "",
            "imgUrl": "/assets/questions/phase-validation.png",
            "isSelected": false,
            "subQuestions": []
        },
        "question-3-answer-6": {
            "id": "question-3-answer-6",
            "value": "3.6",
            "i18nDescription": "Assembly",
            "i18nDescriptionText": "",
            "imgUrl": "/assets/questions/phase-assembly.jpg",
            "isSelected": false,
            "subQuestions": []
        },
        "question-3-answer-7": {
            "id": "question-3-answer-7",
            "value": "3.7",
            "i18nDescription": "Actual / daily use",
            "i18nDescriptionText": "",
            "imgUrl": "/assets/questions/phase-actual.png",
            "isSelected": false,
            "subQuestions": []
        }
    },
    "form_data_causes": {
        "question-3-1-answer-1": {
            "id": "question-3-1-answer-1",
            "phase": "Definition of specifications (part requirements)",
            "name": "Not all real-use requirements are taken into account, when defining the part specifications (e.g. metal vs. plastic)",
            "parent": "question-3-answer-1",
            "isSelected": false
        },
        "question-3-1-answer-2": {
            "id": "question-3-1-answer-2",
            "phase": "Definition of specifications (part requirements)",
            "name": "Defined part requirements are not accurately reflecting the real in-use condions",
            "parent": "question-3-answer-1",
            "isSelected": false
        },
        "question-3-2-answer-1": {
            "id": "question-3-2-answer-1",
            "phase": "Selection of material",
            "name": "Selected material does not fulfill required properties",
            "parent": "question-3-answer-2",
            "isSelected": false
        },
        "question-3-2-answer-2": {
            "id": "question-3-2-answer-2",
            "phase": "Selection of material",
            "name": "Not all part manufacturing requirements are considered properly",
            "parent": "question-3-answer-2",
            "isSelected": false
        },
        "question-3-3-answer-1": {
            "id": "question-3-3-answer-1",
            "phase": "Design process",
            "name": "Design for part funtionality",
            "parent": "question-3-answer-3",
            "isSelected": false
        },
        "question-3-3-answer-2": {
            "id": "question-3-3-answer-2",
            "phase": "Design process",
            "name": "Incorrectly simulated prediction of functional capability (mesh resolution, material model, fibre orientation, etc)",
            "parent": "question-3-answer-3",
            "isSelected": false
        },
        "question-3-3-answer-3": {
            "id": "question-3-3-answer-3",
            "phase": "Design process",
            "name": "Wrong inserts selected",
            "parent": "question-3-answer-3",
            "isSelected": false
        },
        "question-3-3-answer-4": {
            "id": "question-3-3-answer-4",
            "phase": "Design process",
            "name": "Local orientation of fibre-reinforcement is not optimal (glassfiber, carbonfiber, etc.)",
            "parent": "question-3-answer-3",
            "isSelected": false
        },
        "question-3-3-answer-5": {
            "id": "question-3-3-answer-5",
            "phase": "Design process",
            "name": "Weld line at critical location",
            "parent": "question-3-answer-3",
            "isSelected": false
        },
        "question-3-3-answer-6": {
            "id": "question-3-3-answer-6",
            "phase": "Design process",
            "name": "Incorrect edge radii (stress concentration)",
            "parent": "question-3-answer-3",
            "isSelected": false
        },
        "question-3-3-answer-7": {
            "id": "question-3-3-answer-7",
            "phase": "Design process",
            "name": "Incorrect wall thickness",
            "parent": "question-3-answer-3",
            "isSelected": false
        },
        "question-3-3-answer-8": {
            "id": "question-3-3-answer-8",
            "phase": "Design process",
            "name": "Ineffective ribbing",
            "parent": "question-3-answer-3",
            "isSelected": false
        },
        "question-3-3-answer-9": {
            "id": "question-3-3-answer-9",
            "phase": "Design process",
            "name": "Ineffective heat dissipation features (cooling ribs, contact with heatsinks)",
            "parent": "question-3-answer-3",
            "isSelected": false
        },
        "question-3-3-answer-10": {
            "id": "question-3-3-answer-10",
            "phase": "Design process",
            "name": "Contact pressure and/or contact speed outside of capability limits",
            "parent": "question-3-answer-3",
            "isSelected": false
        },
        "question-3-3-answer-11": {
            "id": "question-3-3-answer-11",
            "phase": "Design process",
            "name": "Design for Manufacturing",
            "parent": "question-3-answer-3",
            "isSelected": false
        },
        "question-3-3-answer-12": {
            "id": "question-3-3-answer-12",
            "phase": "Design process",
            "name": "Design not optimized for Injection Molding in combination with secondary operations",
            "parent": "question-3-answer-3",
            "isSelected": false
        },
        "question-3-3-answer-13": {
            "id": "question-3-3-answer-13",
            "phase": "Design process",
            "name": "Insufficient release angle",
            "parent": "question-3-answer-3",
            "isSelected": false
        },
        "question-3-3-answer-14": {
            "id": "question-3-3-answer-14",
            "phase": "Design process",
            "name": "Mold design (for warpage, venting, Gas Counter Pressure etc.)",
            "parent": "question-3-answer-3",
            "isSelected": false
        },
        "question-3-3-answer-15": {
            "id": "question-3-3-answer-15",
            "phase": "Design process",
            "name": "Gate locations chosen wrongly",
            "parent": "question-3-answer-3",
            "isSelected": false
        },
        "question-3-3-answer-16": {
            "id": "question-3-3-answer-16",
            "phase": "Design process",
            "name": "Gate dimensions and runner system inadequate",
            "parent": "question-3-answer-3",
            "isSelected": false
        },
        "question-3-3-answer-17": {
            "id": "question-3-3-answer-17",
            "phase": "Design process",
            "name": "Inadequate mold venting",
            "parent": "question-3-answer-3",
            "isSelected": false
        },
        "question-3-3-answer-18": {
            "id": "question-3-3-answer-18",
            "phase": "Design process",
            "name": "Inadequate cooling channel placement",
            "parent": "question-3-answer-3",
            "isSelected": false
        },
        "question-3-3-answer-19": {
            "id": "question-3-3-answer-19",
            "phase": "Design process",
            "name": "Insufficient coring out",
            "parent": "question-3-answer-3",
            "isSelected": false
        },
        "question-3-3-answer-20": {
            "id": "question-3-3-answer-20",
            "phase": "Design process",
            "name": "Design for assembly or dis-assembly",
            "parent": "question-3-answer-3",
            "isSelected": false
        },
        "question-3-3-answer-21": {
            "id": "question-3-3-answer-21",
            "phase": "Design process",
            "name": "Thermal expansion differences between parts not sufficiently considered",
            "parent": "question-3-answer-3",
            "isSelected": false
        },
        "question-3-3-answer-22": {
            "id": "question-3-3-answer-22",
            "phase": "Design process",
            "name": "Assembly sequence and/or constraints not sufficiently considered",
            "parent": "question-3-answer-3",
            "isSelected": false
        },
        "question-3-4-answer-1": {
            "id": "question-3-4-answer-1",
            "phase": "Part manufacturing (focus on injection molding)",
            "name": "Too high amount of volatiles in the melt,  causing blistering and/or outgassing",
            "parent": "question-3-answer-4",
            "isSelected": false
        },
        "question-3-4-answer-2": {
            "id": "question-3-4-answer-2",
            "phase": "Part manufacturing (focus on injection molding)",
            "name": "Mismatch of Mold and Injection Molding machine dimensions",
            "parent": "question-3-answer-4",
            "isSelected": false
        },
        "question-3-4-answer-3": {
            "id": "question-3-4-answer-3",
            "phase": "Part manufacturing (focus on injection molding)",
            "name": "Material  dried insufficiently before processing",
            "parent": "question-3-answer-4",
            "isSelected": false
        },
        "question-3-4-answer-4": {
            "id": "question-3-4-answer-4",
            "phase": "Part manufacturing (focus on injection molding)",
            "name": "Actual machine values are not corresponding with chosen settings (\"Ist\" vs.\"Soll\")",
            "parent": "question-3-answer-4",
            "isSelected": false
        },
        "question-3-4-answer-5": {
            "id": "question-3-4-answer-5",
            "phase": "Part manufacturing (focus on injection molding)",
            "name": "Applied Mold-release incorrect (amount, type, compatibility with secondary operations etc.)",
            "parent": "question-3-answer-4",
            "isSelected": false
        },
        "question-3-4-answer-6": {
            "id": "question-3-4-answer-6",
            "phase": "Part manufacturing (focus on injection molding)",
            "name": "Processing settings chosen outside of material-specific Injection Molding recommendations",
            "parent": "question-3-answer-4",
            "isSelected": false
        },
        "question-3-5-answer-1": {
            "id": "question-3-5-answer-1",
            "phase": "Part validation",
            "name": "Prototype testing does not emulate critical in-use condition; conditions too harsh or too mild",
            "parent": "question-3-answer-5",
            "isSelected": false
        },
        "question-3-5-answer-2": {
            "id": "question-3-5-answer-2",
            "phase": "Part validation",
            "name": "Accelerated testing conditions (higher frequency, load, temperature, duration etc.) introduce failure modes not occurring in real life",
            "parent": "question-3-answer-5",
            "isSelected": false
        },
        "question-3-5-answer-3": {
            "id": "question-3-5-answer-3",
            "phase": "Part validation",
            "name": "Incorrect execution of validation test (incorrect application of loads, environment, conditioning state, settings etc.)",
            "parent": "question-3-answer-5",
            "isSelected": false
        },
        "question-3-5-answer-4": {
            "id": "question-3-5-answer-4",
            "phase": "Part validation",
            "name": "Tested prototypes do not represent mass-production parts",
            "parent": "question-3-answer-5",
            "isSelected": false
        },
        "question-3-6-answer-1": {
            "id": "question-3-6-answer-1",
            "phase": "Assembly",
            "name": "Excessive stress during assembly",
            "parent": "question-3-answer-6",
            "isSelected": false
        },
        "question-3-6-answer-2": {
            "id": "question-3-6-answer-2",
            "phase": "Assembly",
            "name": "Dimensions outside assembly-tolerance",
            "parent": "question-3-answer-6",
            "isSelected": false
        },
        "question-3-7-answer-1": {
            "id": "question-3-7-answer-1",
            "phase": "Actual / daily use",
            "name": "Loads outside of specified (intended) use conditions",
            "parent": "question-3-answer-7",
            "isSelected": false
        },
        "question-3-7-answer-2": {
            "id": "question-3-7-answer-2",
            "phase": "Actual / daily use",
            "name": "Environmental circumstances outside of specified (intended) use conditions",
            "parent": "question-3-answer-7",
            "isSelected": false
        }
    }
}
